/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateWarningInput = {
  id?: string | null,
  title: string,
  description: string,
  group: WarningGroup,
  level: WarningLevel,
  _version?: number | null,
};

export enum WarningGroup {
  General = "General",
  Diving = "Diving",
  Caving = "Caving",
}


export enum WarningLevel {
  Danger = "Danger",
  Warning = "Warning",
  Info = "Info",
}


export type ModelWarningConditionInput = {
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  group?: ModelWarningGroupInput | null,
  level?: ModelWarningLevelInput | null,
  and?: Array< ModelWarningConditionInput | null > | null,
  or?: Array< ModelWarningConditionInput | null > | null,
  not?: ModelWarningConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelWarningGroupInput = {
  eq?: WarningGroup | null,
  ne?: WarningGroup | null,
};

export type ModelWarningLevelInput = {
  eq?: WarningLevel | null,
  ne?: WarningLevel | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Warning = {
  __typename: "Warning",
  id: string,
  title: string,
  description: string,
  group: WarningGroup,
  level: WarningLevel,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateWarningInput = {
  id: string,
  title?: string | null,
  description?: string | null,
  group?: WarningGroup | null,
  level?: WarningLevel | null,
  _version?: number | null,
};

export type DeleteWarningInput = {
  id: string,
  _version?: number | null,
};

export type CreateGroundWaterInput = {
  id?: string | null,
  altitude: number,
  center: LatLonInput,
  radius: number,
  _version?: number | null,
};

export type LatLonInput = {
  lat: number,
  lon: number,
};

export type ModelGroundWaterConditionInput = {
  altitude?: ModelFloatInput | null,
  radius?: ModelFloatInput | null,
  and?: Array< ModelGroundWaterConditionInput | null > | null,
  or?: Array< ModelGroundWaterConditionInput | null > | null,
  not?: ModelGroundWaterConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type GroundWater = {
  __typename: "GroundWater",
  id: string,
  altitude: number,
  center: LatLon,
  radius: number,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
  owner?: string | null,
};

export type LatLon = {
  __typename: "LatLon",
  lat: number,
  lon: number,
};

export type UpdateGroundWaterInput = {
  id: string,
  altitude?: number | null,
  center?: LatLonInput | null,
  radius?: number | null,
  _version?: number | null,
};

export type DeleteGroundWaterInput = {
  id: string,
  _version?: number | null,
};

export type CreatePlaceReportInput = {
  owner?: string | null,
  id?: string | null,
  rating: number,
  waterTemp?: number | null,
  visibility?: ReportVisibility | null,
  swell?: ReportSwell | null,
  wind?: ReportWind | null,
  text: string,
  date: string,
  _version?: number | null,
  placeReportsId?: string | null,
};

export enum ReportVisibility {
  Unspecified = "Unspecified",
  Terrible = "Terrible",
  Bad = "Bad",
  Ok = "Ok",
  Good = "Good",
  Excellent = "Excellent",
  Outstanding = "Outstanding",
}


export enum ReportSwell {
  Unspecified = "Unspecified",
  Calm = "Calm",
  Smooth = "Smooth",
  Slight = "Slight",
  Rough = "Rough",
  Dangerous = "Dangerous",
}


export enum ReportWind {
  Unspecified = "Unspecified",
  LightBreeze = "LightBreeze",
  GentleBreeze = "GentleBreeze",
  ModerateBreeze = "ModerateBreeze",
  FreshBreeze = "FreshBreeze",
  StrongBreeze = "StrongBreeze",
  Dangerous = "Dangerous",
}


export type ModelPlaceReportConditionInput = {
  owner?: ModelIDInput | null,
  rating?: ModelIntInput | null,
  waterTemp?: ModelIntInput | null,
  visibility?: ModelReportVisibilityInput | null,
  swell?: ModelReportSwellInput | null,
  wind?: ModelReportWindInput | null,
  text?: ModelStringInput | null,
  date?: ModelStringInput | null,
  and?: Array< ModelPlaceReportConditionInput | null > | null,
  or?: Array< ModelPlaceReportConditionInput | null > | null,
  not?: ModelPlaceReportConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  placeReportsId?: ModelIDInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelReportVisibilityInput = {
  eq?: ReportVisibility | null,
  ne?: ReportVisibility | null,
};

export type ModelReportSwellInput = {
  eq?: ReportSwell | null,
  ne?: ReportSwell | null,
};

export type ModelReportWindInput = {
  eq?: ReportWind | null,
  ne?: ReportWind | null,
};

export type PlaceReport = {
  __typename: "PlaceReport",
  owner?: string | null,
  id: string,
  rating: number,
  waterTemp?: number | null,
  visibility?: ReportVisibility | null,
  swell?: ReportSwell | null,
  wind?: ReportWind | null,
  text: string,
  date: string,
  place?: Place | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
  placeReportsId?: string | null,
};

export type Place = {
  __typename: "Place",
  id: string,
  data: PlaceData,
  userAccess?: Array< string > | null,
  groupAccess?: Array< string > | null,
  reports?: ModelPlaceReportConnection | null,
  ratings?: ModelPlaceRatingConnection | null,
  media?: ModelPlaceMediaItemConnection | null,
  softDeleted?: string | null,
  scubaCollection?: string | null,
  caveCollection?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type PlaceData = {
  __typename: "PlaceData",
  name: string,
  alternateNames: Array< string >,
  location: LatLon,
  locationKnown: boolean,
  checked: boolean,
  checkedBy: string,
  spelioData: SpelioData,
  diveData?: DiveData | null,
  wreckData?: WreckData | null,
  address?: Address | null,
  altitude?: number | null,
  warnings?: Array< string > | null,
  amenities?: Amenities | null,
};

export type SpelioData = {
  __typename: "SpelioData",
  systemName?: string | null,
  reference: string,
  source: string,
  type: LocationType,
  notes: string,
  caveRating: CaveRating,
  highestCaveRating?: CaveRating | null,
  tourismPotential: TourismPotential,
  accessDetails: string,
  verticalAccess: TriState,
  explorationPotential: ExplorationPotential,
  disabledAccessPotential: DisabledAccessPotential,
  files: Array< string >,
  labels: Array< string >,
  goesToWater: TriState,
  references:  Array<Reference >,
  surveyedLength?: number | null,
};

export enum LocationType {
  Unknown = "Unknown",
  NotFound = "NotFound",
  Depression = "Depression",
  Cave = "Cave",
  Sinkhole = "Sinkhole",
  SolutionTube = "SolutionTube",
  Destroyed = "Destroyed",
  RockyOutcrop = "RockyOutcrop",
  Landmark = "Landmark",
  Mine = "Mine",
  Wreck = "Wreck",
  Reef = "Reef",
  Jetty = "Jetty",
  Muck = "Muck",
  Sand = "Sand",
  OceanWall = "OceanWall",
  Campsite = "Campsite",
}


export enum CaveRating {
  Unknown = "Unknown",
  None = "None",
  OpenWater = "OpenWater",
  Basic = "Basic",
  Cave = "Cave",
  Advanced = "Advanced",
}


export enum TourismPotential {
  Unknown = "Unknown",
  None = "None",
  Low = "Low",
  Medium = "Medium",
  High = "High",
}


export enum TriState {
  Unknown = "Unknown",
  No = "No",
  Yes = "Yes",
}


export enum ExplorationPotential {
  Unknown = "Unknown",
  None = "None",
  Low = "Low",
  Medium = "Medium",
  High = "High",
  VeryHigh = "VeryHigh",
}


export enum DisabledAccessPotential {
  Unknown = "Unknown",
  None = "None",
  Low = "Low",
  Medium = "Medium",
  High = "High",
}


export type Reference = {
  __typename: "Reference",
  name: string,
  text: string,
};

export type DiveData = {
  __typename: "DiveData",
  minDepth?: number | null,
  maxDepth?: number | null,
  waterType: WaterType,
  isTidal: TriState,
  minTemp?: number | null,
  maxTemp?: number | null,
  difficulty?: Difficulty | null,
  entryDifficulty?: Difficulty | null,
  entryType?: EntryType | null,
};

export enum WaterType {
  Unknown = "Unknown",
  Fresh = "Fresh",
  Salt = "Salt",
}


export enum Difficulty {
  Unknown = "Unknown",
  Easy = "Easy",
  Intermediate = "Intermediate",
  Hard = "Hard",
  VeryHard = "VeryHard",
}


export enum EntryType {
  Unknown = "Unknown",
  Boat = "Boat",
  Shore = "Shore",
}


export type WreckData = {
  __typename: "WreckData",
  type?: string | null,
  built?: string | null,
  dateSunk?: string | null,
  length?: number | null,
  width?: number | null,
  draught?: number | null,
};

export type Address = {
  __typename: "Address",
  streetNumber?: string | null,
  street?: string | null,
  suburb?: string | null,
  state?: string | null,
  country?: string | null,
  postcode?: string | null,
  timezone?: string | null,
};

export type Amenities = {
  __typename: "Amenities",
  hasShowers: TriState,
  hasToilets: TriState,
  hasPhone?: TriState | null,
  food?: Rating | null,
  family?: Rating | null,
  parking?: Rating | null,
};

export enum Rating {
  Unknown = "Unknown",
  None = "None",
  Terrible = "Terrible",
  Bad = "Bad",
  Ok = "Ok",
  Good = "Good",
  Excellent = "Excellent",
  Outstanding = "Outstanding",
}


export type ModelPlaceReportConnection = {
  __typename: "ModelPlaceReportConnection",
  items:  Array<PlaceReport | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelPlaceRatingConnection = {
  __typename: "ModelPlaceRatingConnection",
  items:  Array<PlaceRating | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type PlaceRating = {
  __typename: "PlaceRating",
  id: string,
  rating: number,
  place?: Place | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
  placeRatingsId?: string | null,
  owner?: string | null,
};

export type ModelPlaceMediaItemConnection = {
  __typename: "ModelPlaceMediaItemConnection",
  items:  Array<PlaceMediaItem | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type PlaceMediaItem = {
  __typename: "PlaceMediaItem",
  id: string,
  owner?: string | null,
  groupAccess?: Array< string > | null,
  media?: Media | null,
  placeMediaId?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type Media = {
  __typename: "Media",
  id: string,
  contributorId?: string | null,
  mimeType: string,
  file: S3Object,
  thumbnail_256px?: S3Object | null,
  thumbnail_512px?: S3Object | null,
  thumbnail_1024px?: S3Object | null,
  name?: string | null,
  description?: string | null,
  contentType?: MediaContentType | null,
  attribution?: string | null,
  attributionLink?: string | null,
  dateAdded?: string | null,
  dateCreated?: string | null,
};

export type S3Object = {
  __typename: "S3Object",
  bucket: string,
  region: string,
  key: string,
};

export enum MediaContentType {
  ArticleCover = "ArticleCover",
  EntryPoint = "EntryPoint",
  Site = "Site",
  Map = "Map",
  SurveyData = "SurveyData",
  TrackData = "TrackData",
  Wildlife = "Wildlife",
}


export type UpdatePlaceReportInput = {
  owner?: string | null,
  id: string,
  rating?: number | null,
  waterTemp?: number | null,
  visibility?: ReportVisibility | null,
  swell?: ReportSwell | null,
  wind?: ReportWind | null,
  text?: string | null,
  date?: string | null,
  _version?: number | null,
  placeReportsId?: string | null,
};

export type DeletePlaceReportInput = {
  id: string,
  _version?: number | null,
};

export type CreatePlaceRatingInput = {
  id?: string | null,
  rating: number,
  _version?: number | null,
  placeRatingsId?: string | null,
};

export type ModelPlaceRatingConditionInput = {
  rating?: ModelIntInput | null,
  and?: Array< ModelPlaceRatingConditionInput | null > | null,
  or?: Array< ModelPlaceRatingConditionInput | null > | null,
  not?: ModelPlaceRatingConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  placeRatingsId?: ModelIDInput | null,
};

export type UpdatePlaceRatingInput = {
  id: string,
  rating?: number | null,
  _version?: number | null,
  placeRatingsId?: string | null,
};

export type DeletePlaceRatingInput = {
  id: string,
  _version?: number | null,
};

export type CreatePlaceMediaItemInput = {
  id?: string | null,
  owner?: string | null,
  groupAccess?: Array< string > | null,
  media?: MediaInput | null,
  placeMediaId?: string | null,
  _version?: number | null,
};

export type MediaInput = {
  id: string,
  contributorId?: string | null,
  mimeType: string,
  file: S3ObjectInput,
  thumbnail_256px?: S3ObjectInput | null,
  thumbnail_512px?: S3ObjectInput | null,
  thumbnail_1024px?: S3ObjectInput | null,
  name?: string | null,
  description?: string | null,
  contentType?: MediaContentType | null,
  attribution?: string | null,
  attributionLink?: string | null,
  dateAdded?: string | null,
  dateCreated?: string | null,
};

export type S3ObjectInput = {
  bucket: string,
  region: string,
  localUri?: string | null,
  visibility?: ReportVisibility | null,
  key?: string | null,
  mimeType?: string | null,
};

export type ModelPlaceMediaItemConditionInput = {
  owner?: ModelIDInput | null,
  groupAccess?: ModelStringInput | null,
  placeMediaId?: ModelIDInput | null,
  and?: Array< ModelPlaceMediaItemConditionInput | null > | null,
  or?: Array< ModelPlaceMediaItemConditionInput | null > | null,
  not?: ModelPlaceMediaItemConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdatePlaceMediaItemInput = {
  id: string,
  owner?: string | null,
  groupAccess?: Array< string > | null,
  media?: MediaInput | null,
  placeMediaId?: string | null,
  _version?: number | null,
};

export type DeletePlaceMediaItemInput = {
  id: string,
  _version?: number | null,
};

export type CreatePlaceInput = {
  id?: string | null,
  data: PlaceDataInput,
  userAccess?: Array< string > | null,
  groupAccess?: Array< string > | null,
  softDeleted?: string | null,
  scubaCollection?: string | null,
  caveCollection?: string | null,
  _version?: number | null,
};

export type PlaceDataInput = {
  name: string,
  alternateNames: Array< string >,
  location: LatLonInput,
  locationKnown: boolean,
  checked: boolean,
  checkedBy: string,
  spelioData: SpelioDataInput,
  diveData?: DiveDataInput | null,
  wreckData?: WreckDataInput | null,
  address?: AddressInput | null,
  altitude?: number | null,
  warnings?: Array< string > | null,
  amenities?: AmenitiesInput | null,
};

export type SpelioDataInput = {
  systemName?: string | null,
  reference: string,
  source: string,
  type: LocationType,
  notes: string,
  caveRating: CaveRating,
  highestCaveRating?: CaveRating | null,
  tourismPotential: TourismPotential,
  accessDetails: string,
  verticalAccess: TriState,
  explorationPotential: ExplorationPotential,
  disabledAccessPotential: DisabledAccessPotential,
  files: Array< string >,
  labels: Array< string >,
  goesToWater: TriState,
  references: Array< ReferenceInput >,
  surveyedLength?: number | null,
};

export type ReferenceInput = {
  name: string,
  text: string,
};

export type DiveDataInput = {
  minDepth?: number | null,
  maxDepth?: number | null,
  waterType: WaterType,
  isTidal: TriState,
  minTemp?: number | null,
  maxTemp?: number | null,
  difficulty?: Difficulty | null,
  entryDifficulty?: Difficulty | null,
  entryType?: EntryType | null,
};

export type WreckDataInput = {
  type?: string | null,
  built?: string | null,
  dateSunk?: string | null,
  length?: number | null,
  width?: number | null,
  draught?: number | null,
};

export type AddressInput = {
  streetNumber?: string | null,
  street?: string | null,
  suburb?: string | null,
  state?: string | null,
  country?: string | null,
  postcode?: string | null,
  timezone?: string | null,
};

export type AmenitiesInput = {
  hasShowers: TriState,
  hasToilets: TriState,
  hasPhone?: TriState | null,
  food?: Rating | null,
  family?: Rating | null,
  parking?: Rating | null,
};

export type ModelPlaceConditionInput = {
  userAccess?: ModelStringInput | null,
  groupAccess?: ModelStringInput | null,
  softDeleted?: ModelStringInput | null,
  scubaCollection?: ModelStringInput | null,
  caveCollection?: ModelStringInput | null,
  and?: Array< ModelPlaceConditionInput | null > | null,
  or?: Array< ModelPlaceConditionInput | null > | null,
  not?: ModelPlaceConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdatePlaceInput = {
  id: string,
  data?: PlaceDataInput | null,
  userAccess?: Array< string > | null,
  groupAccess?: Array< string > | null,
  softDeleted?: string | null,
  scubaCollection?: string | null,
  caveCollection?: string | null,
  _version?: number | null,
};

export type DeletePlaceInput = {
  id: string,
  _version?: number | null,
};

export type CreateJournalInput = {
  id?: string | null,
  addedAt: string,
  scubaCollection?: string | null,
  caveCollection?: string | null,
  modifications: Array< ModificationInput >,
  modification?: ModificationInput | null,
  userAccess?: Array< string > | null,
  groupAccess?: Array< string > | null,
  contributor?: string | null,
  owner?: string | null,
  _version?: number | null,
};

export type ModificationInput = {
  action: ModificationAction,
  model: ModificationModel,
  modelId: string,
  modelName: string,
  detail: string,
  collections?: string | null,
};

export enum ModificationAction {
  Create = "Create",
  Update = "Update",
  Delete = "Delete",
}


export enum ModificationModel {
  Place = "Place",
}


export type ModelJournalConditionInput = {
  addedAt?: ModelStringInput | null,
  scubaCollection?: ModelStringInput | null,
  caveCollection?: ModelStringInput | null,
  userAccess?: ModelStringInput | null,
  groupAccess?: ModelStringInput | null,
  contributor?: ModelIDInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelJournalConditionInput | null > | null,
  or?: Array< ModelJournalConditionInput | null > | null,
  not?: ModelJournalConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type Journal = {
  __typename: "Journal",
  id: string,
  addedAt: string,
  scubaCollection?: string | null,
  caveCollection?: string | null,
  modifications:  Array<Modification >,
  modification?: Modification | null,
  userAccess?: Array< string > | null,
  groupAccess?: Array< string > | null,
  contributor?: string | null,
  owner?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type Modification = {
  __typename: "Modification",
  action: ModificationAction,
  model: ModificationModel,
  modelId: string,
  modelName: string,
  detail: string,
  collections?: string | null,
};

export type UpdateJournalInput = {
  id: string,
  addedAt?: string | null,
  scubaCollection?: string | null,
  caveCollection?: string | null,
  modifications?: Array< ModificationInput > | null,
  modification?: ModificationInput | null,
  userAccess?: Array< string > | null,
  groupAccess?: Array< string > | null,
  contributor?: string | null,
  owner?: string | null,
  _version?: number | null,
};

export type DeleteJournalInput = {
  id: string,
  _version?: number | null,
};

export type CreateUserInfoInput = {
  id?: string | null,
  avatar?: MediaInput | null,
  banner?: MediaInput | null,
  displayName?: string | null,
  navigationAccuracy?: number | null,
  displayUnits?: DisplayUnits | null,
  socials?: UserSocialsInput | null,
  isTestAccount?: boolean | null,
  bio?: string | null,
  owner?: string | null,
  _version?: number | null,
};

export enum DisplayUnits {
  Metric = "Metric",
  Imperial = "Imperial",
  Both = "Both",
}


export type UserSocialsInput = {
  website?: string | null,
  facebook?: string | null,
  x?: string | null,
  blueSky?: string | null,
  instagram?: string | null,
};

export type ModelUserInfoConditionInput = {
  displayName?: ModelStringInput | null,
  navigationAccuracy?: ModelFloatInput | null,
  displayUnits?: ModelDisplayUnitsInput | null,
  isTestAccount?: ModelBooleanInput | null,
  bio?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelUserInfoConditionInput | null > | null,
  or?: Array< ModelUserInfoConditionInput | null > | null,
  not?: ModelUserInfoConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelDisplayUnitsInput = {
  eq?: DisplayUnits | null,
  ne?: DisplayUnits | null,
};

export type UserInfo = {
  __typename: "UserInfo",
  id: string,
  avatar?: Media | null,
  banner?: Media | null,
  displayName?: string | null,
  navigationAccuracy?: number | null,
  displayUnits?: DisplayUnits | null,
  socials?: UserSocials | null,
  isTestAccount?: boolean | null,
  bio?: string | null,
  owner?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UserSocials = {
  __typename: "UserSocials",
  website?: string | null,
  facebook?: string | null,
  x?: string | null,
  blueSky?: string | null,
  instagram?: string | null,
};

export type UpdateUserInfoInput = {
  id: string,
  avatar?: MediaInput | null,
  banner?: MediaInput | null,
  displayName?: string | null,
  navigationAccuracy?: number | null,
  displayUnits?: DisplayUnits | null,
  socials?: UserSocialsInput | null,
  isTestAccount?: boolean | null,
  bio?: string | null,
  owner?: string | null,
  _version?: number | null,
};

export type DeleteUserInfoInput = {
  id: string,
  _version?: number | null,
};

export type CreateUserFilterInput = {
  id?: string | null,
  name: string,
  filterVersion: number,
  filter: string,
  _version?: number | null,
};

export type ModelUserFilterConditionInput = {
  name?: ModelStringInput | null,
  filterVersion?: ModelIntInput | null,
  filter?: ModelStringInput | null,
  and?: Array< ModelUserFilterConditionInput | null > | null,
  or?: Array< ModelUserFilterConditionInput | null > | null,
  not?: ModelUserFilterConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UserFilter = {
  __typename: "UserFilter",
  id: string,
  name: string,
  filterVersion: number,
  filter: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
  owner?: string | null,
};

export type UpdateUserFilterInput = {
  id: string,
  name?: string | null,
  filterVersion?: number | null,
  filter?: string | null,
  _version?: number | null,
};

export type DeleteUserFilterInput = {
  id: string,
  _version?: number | null,
};

export type CreatePublicFilterInput = {
  id?: string | null,
  name: string,
  filterVersion: number,
  filter: string,
  _version?: number | null,
};

export type ModelPublicFilterConditionInput = {
  name?: ModelStringInput | null,
  filterVersion?: ModelIntInput | null,
  filter?: ModelStringInput | null,
  and?: Array< ModelPublicFilterConditionInput | null > | null,
  or?: Array< ModelPublicFilterConditionInput | null > | null,
  not?: ModelPublicFilterConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type PublicFilter = {
  __typename: "PublicFilter",
  id: string,
  name: string,
  filterVersion: number,
  filter: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdatePublicFilterInput = {
  id: string,
  name?: string | null,
  filterVersion?: number | null,
  filter?: string | null,
  _version?: number | null,
};

export type DeletePublicFilterInput = {
  id: string,
  _version?: number | null,
};

export type CreateModerationRequestInput = {
  id?: string | null,
  anonymous?: boolean | null,
  payload: string,
  type: ModerationRequestType,
  status: ModerationStatus,
  groupAccess?: Array< string > | null,
  _version?: number | null,
};

export enum ModerationRequestType {
  Place = "Place",
}


export enum ModerationStatus {
  Submitted = "Submitted",
  InReview = "InReview",
  Returned = "Returned",
  Approved = "Approved",
  Rejected = "Rejected",
}


export type ModelModerationRequestConditionInput = {
  anonymous?: ModelBooleanInput | null,
  payload?: ModelStringInput | null,
  type?: ModelModerationRequestTypeInput | null,
  status?: ModelModerationStatusInput | null,
  groupAccess?: ModelStringInput | null,
  and?: Array< ModelModerationRequestConditionInput | null > | null,
  or?: Array< ModelModerationRequestConditionInput | null > | null,
  not?: ModelModerationRequestConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelModerationRequestTypeInput = {
  eq?: ModerationRequestType | null,
  ne?: ModerationRequestType | null,
};

export type ModelModerationStatusInput = {
  eq?: ModerationStatus | null,
  ne?: ModerationStatus | null,
};

export type ModerationRequest = {
  __typename: "ModerationRequest",
  id: string,
  anonymous?: boolean | null,
  payload: string,
  type: ModerationRequestType,
  status: ModerationStatus,
  groupAccess?: Array< string > | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
  owner?: string | null,
};

export type UpdateModerationRequestInput = {
  id: string,
  anonymous?: boolean | null,
  payload?: string | null,
  type?: ModerationRequestType | null,
  status?: ModerationStatus | null,
  groupAccess?: Array< string > | null,
  _version?: number | null,
};

export type DeleteModerationRequestInput = {
  id: string,
  _version?: number | null,
};

export type CreatePlaceListEntryInput = {
  id?: string | null,
  place: string,
  order: number,
  checked?: boolean | null,
  _version?: number | null,
  placeListEntriesId?: string | null,
};

export type ModelPlaceListEntryConditionInput = {
  place?: ModelIDInput | null,
  order?: ModelIntInput | null,
  checked?: ModelBooleanInput | null,
  and?: Array< ModelPlaceListEntryConditionInput | null > | null,
  or?: Array< ModelPlaceListEntryConditionInput | null > | null,
  not?: ModelPlaceListEntryConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  placeListEntriesId?: ModelIDInput | null,
};

export type PlaceListEntry = {
  __typename: "PlaceListEntry",
  id: string,
  placeList?: PlaceList | null,
  place: string,
  order: number,
  checked?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
  placeListEntriesId?: string | null,
  owner?: string | null,
};

export type PlaceList = {
  __typename: "PlaceList",
  id: string,
  name: string,
  description?: string | null,
  entries?: ModelPlaceListEntryConnection | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
  owner?: string | null,
};

export type ModelPlaceListEntryConnection = {
  __typename: "ModelPlaceListEntryConnection",
  items:  Array<PlaceListEntry | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type UpdatePlaceListEntryInput = {
  id: string,
  place?: string | null,
  order?: number | null,
  checked?: boolean | null,
  _version?: number | null,
  placeListEntriesId?: string | null,
};

export type DeletePlaceListEntryInput = {
  id: string,
  _version?: number | null,
};

export type CreatePlaceListInput = {
  id?: string | null,
  name: string,
  description?: string | null,
  _version?: number | null,
};

export type ModelPlaceListConditionInput = {
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelPlaceListConditionInput | null > | null,
  or?: Array< ModelPlaceListConditionInput | null > | null,
  not?: ModelPlaceListConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type UpdatePlaceListInput = {
  id: string,
  name?: string | null,
  description?: string | null,
  _version?: number | null,
};

export type DeletePlaceListInput = {
  id: string,
  _version?: number | null,
};

export type ModelWarningFilterInput = {
  id?: ModelIDInput | null,
  title?: ModelStringInput | null,
  description?: ModelStringInput | null,
  group?: ModelWarningGroupInput | null,
  level?: ModelWarningLevelInput | null,
  and?: Array< ModelWarningFilterInput | null > | null,
  or?: Array< ModelWarningFilterInput | null > | null,
  not?: ModelWarningFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelWarningConnection = {
  __typename: "ModelWarningConnection",
  items:  Array<Warning | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelGroundWaterFilterInput = {
  id?: ModelIDInput | null,
  altitude?: ModelFloatInput | null,
  radius?: ModelFloatInput | null,
  and?: Array< ModelGroundWaterFilterInput | null > | null,
  or?: Array< ModelGroundWaterFilterInput | null > | null,
  not?: ModelGroundWaterFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelGroundWaterConnection = {
  __typename: "ModelGroundWaterConnection",
  items:  Array<GroundWater | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelPlaceReportFilterInput = {
  owner?: ModelIDInput | null,
  id?: ModelIDInput | null,
  rating?: ModelIntInput | null,
  waterTemp?: ModelIntInput | null,
  visibility?: ModelReportVisibilityInput | null,
  swell?: ModelReportSwellInput | null,
  wind?: ModelReportWindInput | null,
  text?: ModelStringInput | null,
  date?: ModelStringInput | null,
  and?: Array< ModelPlaceReportFilterInput | null > | null,
  or?: Array< ModelPlaceReportFilterInput | null > | null,
  not?: ModelPlaceReportFilterInput | null,
  _deleted?: ModelBooleanInput | null,
  placeReportsId?: ModelIDInput | null,
};

export type ModelPlaceRatingFilterInput = {
  id?: ModelIDInput | null,
  rating?: ModelIntInput | null,
  and?: Array< ModelPlaceRatingFilterInput | null > | null,
  or?: Array< ModelPlaceRatingFilterInput | null > | null,
  not?: ModelPlaceRatingFilterInput | null,
  _deleted?: ModelBooleanInput | null,
  placeRatingsId?: ModelIDInput | null,
};

export type ModelPlaceMediaItemFilterInput = {
  id?: ModelIDInput | null,
  owner?: ModelIDInput | null,
  groupAccess?: ModelStringInput | null,
  placeMediaId?: ModelIDInput | null,
  and?: Array< ModelPlaceMediaItemFilterInput | null > | null,
  or?: Array< ModelPlaceMediaItemFilterInput | null > | null,
  not?: ModelPlaceMediaItemFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelPlaceFilterInput = {
  id?: ModelIDInput | null,
  userAccess?: ModelStringInput | null,
  groupAccess?: ModelStringInput | null,
  softDeleted?: ModelStringInput | null,
  scubaCollection?: ModelStringInput | null,
  caveCollection?: ModelStringInput | null,
  and?: Array< ModelPlaceFilterInput | null > | null,
  or?: Array< ModelPlaceFilterInput | null > | null,
  not?: ModelPlaceFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelPlaceConnection = {
  __typename: "ModelPlaceConnection",
  items:  Array<Place | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelJournalFilterInput = {
  id?: ModelIDInput | null,
  addedAt?: ModelStringInput | null,
  scubaCollection?: ModelStringInput | null,
  caveCollection?: ModelStringInput | null,
  userAccess?: ModelStringInput | null,
  groupAccess?: ModelStringInput | null,
  contributor?: ModelIDInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelJournalFilterInput | null > | null,
  or?: Array< ModelJournalFilterInput | null > | null,
  not?: ModelJournalFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelJournalConnection = {
  __typename: "ModelJournalConnection",
  items:  Array<Journal | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUserInfoFilterInput = {
  id?: ModelIDInput | null,
  displayName?: ModelStringInput | null,
  navigationAccuracy?: ModelFloatInput | null,
  displayUnits?: ModelDisplayUnitsInput | null,
  isTestAccount?: ModelBooleanInput | null,
  bio?: ModelStringInput | null,
  owner?: ModelStringInput | null,
  and?: Array< ModelUserInfoFilterInput | null > | null,
  or?: Array< ModelUserInfoFilterInput | null > | null,
  not?: ModelUserInfoFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserInfoConnection = {
  __typename: "ModelUserInfoConnection",
  items:  Array<UserInfo | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelUserFilterFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  filterVersion?: ModelIntInput | null,
  filter?: ModelStringInput | null,
  and?: Array< ModelUserFilterFilterInput | null > | null,
  or?: Array< ModelUserFilterFilterInput | null > | null,
  not?: ModelUserFilterFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelUserFilterConnection = {
  __typename: "ModelUserFilterConnection",
  items:  Array<UserFilter | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelPublicFilterFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  filterVersion?: ModelIntInput | null,
  filter?: ModelStringInput | null,
  and?: Array< ModelPublicFilterFilterInput | null > | null,
  or?: Array< ModelPublicFilterFilterInput | null > | null,
  not?: ModelPublicFilterFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelPublicFilterConnection = {
  __typename: "ModelPublicFilterConnection",
  items:  Array<PublicFilter | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelModerationRequestFilterInput = {
  id?: ModelIDInput | null,
  anonymous?: ModelBooleanInput | null,
  payload?: ModelStringInput | null,
  type?: ModelModerationRequestTypeInput | null,
  status?: ModelModerationStatusInput | null,
  groupAccess?: ModelStringInput | null,
  and?: Array< ModelModerationRequestFilterInput | null > | null,
  or?: Array< ModelModerationRequestFilterInput | null > | null,
  not?: ModelModerationRequestFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelModerationRequestConnection = {
  __typename: "ModelModerationRequestConnection",
  items:  Array<ModerationRequest | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelPlaceListEntryFilterInput = {
  id?: ModelIDInput | null,
  place?: ModelIDInput | null,
  order?: ModelIntInput | null,
  checked?: ModelBooleanInput | null,
  and?: Array< ModelPlaceListEntryFilterInput | null > | null,
  or?: Array< ModelPlaceListEntryFilterInput | null > | null,
  not?: ModelPlaceListEntryFilterInput | null,
  _deleted?: ModelBooleanInput | null,
  placeListEntriesId?: ModelIDInput | null,
};

export type ModelPlaceListFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  and?: Array< ModelPlaceListFilterInput | null > | null,
  or?: Array< ModelPlaceListFilterInput | null > | null,
  not?: ModelPlaceListFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelPlaceListConnection = {
  __typename: "ModelPlaceListConnection",
  items:  Array<PlaceList | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelSubscriptionWarningFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  title?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  group?: ModelSubscriptionStringInput | null,
  level?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionWarningFilterInput | null > | null,
  or?: Array< ModelSubscriptionWarningFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionGroundWaterFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  altitude?: ModelSubscriptionFloatInput | null,
  radius?: ModelSubscriptionFloatInput | null,
  and?: Array< ModelSubscriptionGroundWaterFilterInput | null > | null,
  or?: Array< ModelSubscriptionGroundWaterFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionPlaceReportFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  rating?: ModelSubscriptionIntInput | null,
  waterTemp?: ModelSubscriptionIntInput | null,
  visibility?: ModelSubscriptionStringInput | null,
  swell?: ModelSubscriptionStringInput | null,
  wind?: ModelSubscriptionStringInput | null,
  text?: ModelSubscriptionStringInput | null,
  date?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPlaceReportFilterInput | null > | null,
  or?: Array< ModelSubscriptionPlaceReportFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  in?: Array< number | null > | null,
  notIn?: Array< number | null > | null,
};

export type ModelSubscriptionPlaceRatingFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  rating?: ModelSubscriptionIntInput | null,
  and?: Array< ModelSubscriptionPlaceRatingFilterInput | null > | null,
  or?: Array< ModelSubscriptionPlaceRatingFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionPlaceMediaItemFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  owner?: ModelSubscriptionIDInput | null,
  groupAccess?: ModelSubscriptionStringInput | null,
  placeMediaId?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionPlaceMediaItemFilterInput | null > | null,
  or?: Array< ModelSubscriptionPlaceMediaItemFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionPlaceFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userAccess?: ModelSubscriptionStringInput | null,
  groupAccess?: ModelSubscriptionStringInput | null,
  softDeleted?: ModelSubscriptionStringInput | null,
  scubaCollection?: ModelSubscriptionStringInput | null,
  caveCollection?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPlaceFilterInput | null > | null,
  or?: Array< ModelSubscriptionPlaceFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionJournalFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  addedAt?: ModelSubscriptionStringInput | null,
  scubaCollection?: ModelSubscriptionStringInput | null,
  caveCollection?: ModelSubscriptionStringInput | null,
  userAccess?: ModelSubscriptionStringInput | null,
  groupAccess?: ModelSubscriptionStringInput | null,
  contributor?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionJournalFilterInput | null > | null,
  or?: Array< ModelSubscriptionJournalFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionUserInfoFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  displayName?: ModelSubscriptionStringInput | null,
  navigationAccuracy?: ModelSubscriptionFloatInput | null,
  displayUnits?: ModelSubscriptionStringInput | null,
  isTestAccount?: ModelSubscriptionBooleanInput | null,
  bio?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserInfoFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserInfoFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionUserFilterFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  filterVersion?: ModelSubscriptionIntInput | null,
  filter?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionUserFilterFilterInput | null > | null,
  or?: Array< ModelSubscriptionUserFilterFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionPublicFilterFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  filterVersion?: ModelSubscriptionIntInput | null,
  filter?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPublicFilterFilterInput | null > | null,
  or?: Array< ModelSubscriptionPublicFilterFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionModerationRequestFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  anonymous?: ModelSubscriptionBooleanInput | null,
  payload?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  status?: ModelSubscriptionStringInput | null,
  groupAccess?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionModerationRequestFilterInput | null > | null,
  or?: Array< ModelSubscriptionModerationRequestFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionPlaceListEntryFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  place?: ModelSubscriptionIDInput | null,
  order?: ModelSubscriptionIntInput | null,
  checked?: ModelSubscriptionBooleanInput | null,
  and?: Array< ModelSubscriptionPlaceListEntryFilterInput | null > | null,
  or?: Array< ModelSubscriptionPlaceListEntryFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelSubscriptionPlaceListFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  description?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionPlaceListFilterInput | null > | null,
  or?: Array< ModelSubscriptionPlaceListFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
};

export type CreateWarningMutationVariables = {
  input: CreateWarningInput,
  condition?: ModelWarningConditionInput | null,
};

export type CreateWarningMutation = {
  createWarning?:  {
    __typename: "Warning",
    id: string,
    title: string,
    description: string,
    group: WarningGroup,
    level: WarningLevel,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateWarningMutationVariables = {
  input: UpdateWarningInput,
  condition?: ModelWarningConditionInput | null,
};

export type UpdateWarningMutation = {
  updateWarning?:  {
    __typename: "Warning",
    id: string,
    title: string,
    description: string,
    group: WarningGroup,
    level: WarningLevel,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteWarningMutationVariables = {
  input: DeleteWarningInput,
  condition?: ModelWarningConditionInput | null,
};

export type DeleteWarningMutation = {
  deleteWarning?:  {
    __typename: "Warning",
    id: string,
    title: string,
    description: string,
    group: WarningGroup,
    level: WarningLevel,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateGroundWaterMutationVariables = {
  input: CreateGroundWaterInput,
  condition?: ModelGroundWaterConditionInput | null,
};

export type CreateGroundWaterMutation = {
  createGroundWater?:  {
    __typename: "GroundWater",
    id: string,
    altitude: number,
    center:  {
      __typename: "LatLon",
      lat: number,
      lon: number,
    },
    radius: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type UpdateGroundWaterMutationVariables = {
  input: UpdateGroundWaterInput,
  condition?: ModelGroundWaterConditionInput | null,
};

export type UpdateGroundWaterMutation = {
  updateGroundWater?:  {
    __typename: "GroundWater",
    id: string,
    altitude: number,
    center:  {
      __typename: "LatLon",
      lat: number,
      lon: number,
    },
    radius: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type DeleteGroundWaterMutationVariables = {
  input: DeleteGroundWaterInput,
  condition?: ModelGroundWaterConditionInput | null,
};

export type DeleteGroundWaterMutation = {
  deleteGroundWater?:  {
    __typename: "GroundWater",
    id: string,
    altitude: number,
    center:  {
      __typename: "LatLon",
      lat: number,
      lon: number,
    },
    radius: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type CreatePlaceReportMutationVariables = {
  input: CreatePlaceReportInput,
  condition?: ModelPlaceReportConditionInput | null,
};

export type CreatePlaceReportMutation = {
  createPlaceReport?:  {
    __typename: "PlaceReport",
    owner?: string | null,
    id: string,
    rating: number,
    waterTemp?: number | null,
    visibility?: ReportVisibility | null,
    swell?: ReportSwell | null,
    wind?: ReportWind | null,
    text: string,
    date: string,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeReportsId?: string | null,
  } | null,
};

export type UpdatePlaceReportMutationVariables = {
  input: UpdatePlaceReportInput,
  condition?: ModelPlaceReportConditionInput | null,
};

export type UpdatePlaceReportMutation = {
  updatePlaceReport?:  {
    __typename: "PlaceReport",
    owner?: string | null,
    id: string,
    rating: number,
    waterTemp?: number | null,
    visibility?: ReportVisibility | null,
    swell?: ReportSwell | null,
    wind?: ReportWind | null,
    text: string,
    date: string,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeReportsId?: string | null,
  } | null,
};

export type DeletePlaceReportMutationVariables = {
  input: DeletePlaceReportInput,
  condition?: ModelPlaceReportConditionInput | null,
};

export type DeletePlaceReportMutation = {
  deletePlaceReport?:  {
    __typename: "PlaceReport",
    owner?: string | null,
    id: string,
    rating: number,
    waterTemp?: number | null,
    visibility?: ReportVisibility | null,
    swell?: ReportSwell | null,
    wind?: ReportWind | null,
    text: string,
    date: string,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeReportsId?: string | null,
  } | null,
};

export type CreatePlaceRatingMutationVariables = {
  input: CreatePlaceRatingInput,
  condition?: ModelPlaceRatingConditionInput | null,
};

export type CreatePlaceRatingMutation = {
  createPlaceRating?:  {
    __typename: "PlaceRating",
    id: string,
    rating: number,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeRatingsId?: string | null,
    owner?: string | null,
  } | null,
};

export type UpdatePlaceRatingMutationVariables = {
  input: UpdatePlaceRatingInput,
  condition?: ModelPlaceRatingConditionInput | null,
};

export type UpdatePlaceRatingMutation = {
  updatePlaceRating?:  {
    __typename: "PlaceRating",
    id: string,
    rating: number,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeRatingsId?: string | null,
    owner?: string | null,
  } | null,
};

export type DeletePlaceRatingMutationVariables = {
  input: DeletePlaceRatingInput,
  condition?: ModelPlaceRatingConditionInput | null,
};

export type DeletePlaceRatingMutation = {
  deletePlaceRating?:  {
    __typename: "PlaceRating",
    id: string,
    rating: number,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeRatingsId?: string | null,
    owner?: string | null,
  } | null,
};

export type CreatePlaceMediaItemMutationVariables = {
  input: CreatePlaceMediaItemInput,
  condition?: ModelPlaceMediaItemConditionInput | null,
};

export type CreatePlaceMediaItemMutation = {
  createPlaceMediaItem?:  {
    __typename: "PlaceMediaItem",
    id: string,
    owner?: string | null,
    groupAccess?: Array< string > | null,
    media?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    placeMediaId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdatePlaceMediaItemMutationVariables = {
  input: UpdatePlaceMediaItemInput,
  condition?: ModelPlaceMediaItemConditionInput | null,
};

export type UpdatePlaceMediaItemMutation = {
  updatePlaceMediaItem?:  {
    __typename: "PlaceMediaItem",
    id: string,
    owner?: string | null,
    groupAccess?: Array< string > | null,
    media?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    placeMediaId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeletePlaceMediaItemMutationVariables = {
  input: DeletePlaceMediaItemInput,
  condition?: ModelPlaceMediaItemConditionInput | null,
};

export type DeletePlaceMediaItemMutation = {
  deletePlaceMediaItem?:  {
    __typename: "PlaceMediaItem",
    id: string,
    owner?: string | null,
    groupAccess?: Array< string > | null,
    media?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    placeMediaId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreatePlaceMutationVariables = {
  input: CreatePlaceInput,
  condition?: ModelPlaceConditionInput | null,
};

export type CreatePlaceMutation = {
  createPlace?:  {
    __typename: "Place",
    id: string,
    data:  {
      __typename: "PlaceData",
      name: string,
      alternateNames: Array< string >,
      location:  {
        __typename: "LatLon",
        lat: number,
        lon: number,
      },
      locationKnown: boolean,
      checked: boolean,
      checkedBy: string,
      spelioData:  {
        __typename: "SpelioData",
        systemName?: string | null,
        reference: string,
        source: string,
        type: LocationType,
        notes: string,
        caveRating: CaveRating,
        highestCaveRating?: CaveRating | null,
        tourismPotential: TourismPotential,
        accessDetails: string,
        verticalAccess: TriState,
        explorationPotential: ExplorationPotential,
        disabledAccessPotential: DisabledAccessPotential,
        files: Array< string >,
        labels: Array< string >,
        goesToWater: TriState,
        references:  Array< {
          __typename: "Reference",
          name: string,
          text: string,
        } >,
        surveyedLength?: number | null,
      },
      diveData?:  {
        __typename: "DiveData",
        minDepth?: number | null,
        maxDepth?: number | null,
        waterType: WaterType,
        isTidal: TriState,
        minTemp?: number | null,
        maxTemp?: number | null,
        difficulty?: Difficulty | null,
        entryDifficulty?: Difficulty | null,
        entryType?: EntryType | null,
      } | null,
      wreckData?:  {
        __typename: "WreckData",
        type?: string | null,
        built?: string | null,
        dateSunk?: string | null,
        length?: number | null,
        width?: number | null,
        draught?: number | null,
      } | null,
      address?:  {
        __typename: "Address",
        streetNumber?: string | null,
        street?: string | null,
        suburb?: string | null,
        state?: string | null,
        country?: string | null,
        postcode?: string | null,
        timezone?: string | null,
      } | null,
      altitude?: number | null,
      warnings?: Array< string > | null,
      amenities?:  {
        __typename: "Amenities",
        hasShowers: TriState,
        hasToilets: TriState,
        hasPhone?: TriState | null,
        food?: Rating | null,
        family?: Rating | null,
        parking?: Rating | null,
      } | null,
    },
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    reports?:  {
      __typename: "ModelPlaceReportConnection",
      items:  Array< {
        __typename: "PlaceReport",
        owner?: string | null,
        id: string,
        rating: number,
        waterTemp?: number | null,
        visibility?: ReportVisibility | null,
        swell?: ReportSwell | null,
        wind?: ReportWind | null,
        text: string,
        date: string,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeReportsId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    ratings?:  {
      __typename: "ModelPlaceRatingConnection",
      items:  Array< {
        __typename: "PlaceRating",
        id: string,
        rating: number,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeRatingsId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    media?:  {
      __typename: "ModelPlaceMediaItemConnection",
      items:  Array< {
        __typename: "PlaceMediaItem",
        id: string,
        owner?: string | null,
        groupAccess?: Array< string > | null,
        media?:  {
          __typename: "Media",
          id: string,
          contributorId?: string | null,
          mimeType: string,
          file:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail_256px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_512px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_1024px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          name?: string | null,
          description?: string | null,
          contentType?: MediaContentType | null,
          attribution?: string | null,
          attributionLink?: string | null,
          dateAdded?: string | null,
          dateCreated?: string | null,
        } | null,
        placeMediaId?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    softDeleted?: string | null,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdatePlaceMutationVariables = {
  input: UpdatePlaceInput,
  condition?: ModelPlaceConditionInput | null,
};

export type UpdatePlaceMutation = {
  updatePlace?:  {
    __typename: "Place",
    id: string,
    data:  {
      __typename: "PlaceData",
      name: string,
      alternateNames: Array< string >,
      location:  {
        __typename: "LatLon",
        lat: number,
        lon: number,
      },
      locationKnown: boolean,
      checked: boolean,
      checkedBy: string,
      spelioData:  {
        __typename: "SpelioData",
        systemName?: string | null,
        reference: string,
        source: string,
        type: LocationType,
        notes: string,
        caveRating: CaveRating,
        highestCaveRating?: CaveRating | null,
        tourismPotential: TourismPotential,
        accessDetails: string,
        verticalAccess: TriState,
        explorationPotential: ExplorationPotential,
        disabledAccessPotential: DisabledAccessPotential,
        files: Array< string >,
        labels: Array< string >,
        goesToWater: TriState,
        references:  Array< {
          __typename: "Reference",
          name: string,
          text: string,
        } >,
        surveyedLength?: number | null,
      },
      diveData?:  {
        __typename: "DiveData",
        minDepth?: number | null,
        maxDepth?: number | null,
        waterType: WaterType,
        isTidal: TriState,
        minTemp?: number | null,
        maxTemp?: number | null,
        difficulty?: Difficulty | null,
        entryDifficulty?: Difficulty | null,
        entryType?: EntryType | null,
      } | null,
      wreckData?:  {
        __typename: "WreckData",
        type?: string | null,
        built?: string | null,
        dateSunk?: string | null,
        length?: number | null,
        width?: number | null,
        draught?: number | null,
      } | null,
      address?:  {
        __typename: "Address",
        streetNumber?: string | null,
        street?: string | null,
        suburb?: string | null,
        state?: string | null,
        country?: string | null,
        postcode?: string | null,
        timezone?: string | null,
      } | null,
      altitude?: number | null,
      warnings?: Array< string > | null,
      amenities?:  {
        __typename: "Amenities",
        hasShowers: TriState,
        hasToilets: TriState,
        hasPhone?: TriState | null,
        food?: Rating | null,
        family?: Rating | null,
        parking?: Rating | null,
      } | null,
    },
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    reports?:  {
      __typename: "ModelPlaceReportConnection",
      items:  Array< {
        __typename: "PlaceReport",
        owner?: string | null,
        id: string,
        rating: number,
        waterTemp?: number | null,
        visibility?: ReportVisibility | null,
        swell?: ReportSwell | null,
        wind?: ReportWind | null,
        text: string,
        date: string,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeReportsId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    ratings?:  {
      __typename: "ModelPlaceRatingConnection",
      items:  Array< {
        __typename: "PlaceRating",
        id: string,
        rating: number,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeRatingsId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    media?:  {
      __typename: "ModelPlaceMediaItemConnection",
      items:  Array< {
        __typename: "PlaceMediaItem",
        id: string,
        owner?: string | null,
        groupAccess?: Array< string > | null,
        media?:  {
          __typename: "Media",
          id: string,
          contributorId?: string | null,
          mimeType: string,
          file:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail_256px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_512px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_1024px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          name?: string | null,
          description?: string | null,
          contentType?: MediaContentType | null,
          attribution?: string | null,
          attributionLink?: string | null,
          dateAdded?: string | null,
          dateCreated?: string | null,
        } | null,
        placeMediaId?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    softDeleted?: string | null,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeletePlaceMutationVariables = {
  input: DeletePlaceInput,
  condition?: ModelPlaceConditionInput | null,
};

export type DeletePlaceMutation = {
  deletePlace?:  {
    __typename: "Place",
    id: string,
    data:  {
      __typename: "PlaceData",
      name: string,
      alternateNames: Array< string >,
      location:  {
        __typename: "LatLon",
        lat: number,
        lon: number,
      },
      locationKnown: boolean,
      checked: boolean,
      checkedBy: string,
      spelioData:  {
        __typename: "SpelioData",
        systemName?: string | null,
        reference: string,
        source: string,
        type: LocationType,
        notes: string,
        caveRating: CaveRating,
        highestCaveRating?: CaveRating | null,
        tourismPotential: TourismPotential,
        accessDetails: string,
        verticalAccess: TriState,
        explorationPotential: ExplorationPotential,
        disabledAccessPotential: DisabledAccessPotential,
        files: Array< string >,
        labels: Array< string >,
        goesToWater: TriState,
        references:  Array< {
          __typename: "Reference",
          name: string,
          text: string,
        } >,
        surveyedLength?: number | null,
      },
      diveData?:  {
        __typename: "DiveData",
        minDepth?: number | null,
        maxDepth?: number | null,
        waterType: WaterType,
        isTidal: TriState,
        minTemp?: number | null,
        maxTemp?: number | null,
        difficulty?: Difficulty | null,
        entryDifficulty?: Difficulty | null,
        entryType?: EntryType | null,
      } | null,
      wreckData?:  {
        __typename: "WreckData",
        type?: string | null,
        built?: string | null,
        dateSunk?: string | null,
        length?: number | null,
        width?: number | null,
        draught?: number | null,
      } | null,
      address?:  {
        __typename: "Address",
        streetNumber?: string | null,
        street?: string | null,
        suburb?: string | null,
        state?: string | null,
        country?: string | null,
        postcode?: string | null,
        timezone?: string | null,
      } | null,
      altitude?: number | null,
      warnings?: Array< string > | null,
      amenities?:  {
        __typename: "Amenities",
        hasShowers: TriState,
        hasToilets: TriState,
        hasPhone?: TriState | null,
        food?: Rating | null,
        family?: Rating | null,
        parking?: Rating | null,
      } | null,
    },
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    reports?:  {
      __typename: "ModelPlaceReportConnection",
      items:  Array< {
        __typename: "PlaceReport",
        owner?: string | null,
        id: string,
        rating: number,
        waterTemp?: number | null,
        visibility?: ReportVisibility | null,
        swell?: ReportSwell | null,
        wind?: ReportWind | null,
        text: string,
        date: string,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeReportsId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    ratings?:  {
      __typename: "ModelPlaceRatingConnection",
      items:  Array< {
        __typename: "PlaceRating",
        id: string,
        rating: number,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeRatingsId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    media?:  {
      __typename: "ModelPlaceMediaItemConnection",
      items:  Array< {
        __typename: "PlaceMediaItem",
        id: string,
        owner?: string | null,
        groupAccess?: Array< string > | null,
        media?:  {
          __typename: "Media",
          id: string,
          contributorId?: string | null,
          mimeType: string,
          file:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail_256px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_512px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_1024px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          name?: string | null,
          description?: string | null,
          contentType?: MediaContentType | null,
          attribution?: string | null,
          attributionLink?: string | null,
          dateAdded?: string | null,
          dateCreated?: string | null,
        } | null,
        placeMediaId?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    softDeleted?: string | null,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateJournalMutationVariables = {
  input: CreateJournalInput,
  condition?: ModelJournalConditionInput | null,
};

export type CreateJournalMutation = {
  createJournal?:  {
    __typename: "Journal",
    id: string,
    addedAt: string,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    modifications:  Array< {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } >,
    modification?:  {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } | null,
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    contributor?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateJournalMutationVariables = {
  input: UpdateJournalInput,
  condition?: ModelJournalConditionInput | null,
};

export type UpdateJournalMutation = {
  updateJournal?:  {
    __typename: "Journal",
    id: string,
    addedAt: string,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    modifications:  Array< {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } >,
    modification?:  {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } | null,
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    contributor?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteJournalMutationVariables = {
  input: DeleteJournalInput,
  condition?: ModelJournalConditionInput | null,
};

export type DeleteJournalMutation = {
  deleteJournal?:  {
    __typename: "Journal",
    id: string,
    addedAt: string,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    modifications:  Array< {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } >,
    modification?:  {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } | null,
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    contributor?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUserInfoMutationVariables = {
  input: CreateUserInfoInput,
  condition?: ModelUserInfoConditionInput | null,
};

export type CreateUserInfoMutation = {
  createUserInfo?:  {
    __typename: "UserInfo",
    id: string,
    avatar?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    banner?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    displayName?: string | null,
    navigationAccuracy?: number | null,
    displayUnits?: DisplayUnits | null,
    socials?:  {
      __typename: "UserSocials",
      website?: string | null,
      facebook?: string | null,
      x?: string | null,
      blueSky?: string | null,
      instagram?: string | null,
    } | null,
    isTestAccount?: boolean | null,
    bio?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateUserInfoMutationVariables = {
  input: UpdateUserInfoInput,
  condition?: ModelUserInfoConditionInput | null,
};

export type UpdateUserInfoMutation = {
  updateUserInfo?:  {
    __typename: "UserInfo",
    id: string,
    avatar?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    banner?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    displayName?: string | null,
    navigationAccuracy?: number | null,
    displayUnits?: DisplayUnits | null,
    socials?:  {
      __typename: "UserSocials",
      website?: string | null,
      facebook?: string | null,
      x?: string | null,
      blueSky?: string | null,
      instagram?: string | null,
    } | null,
    isTestAccount?: boolean | null,
    bio?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteUserInfoMutationVariables = {
  input: DeleteUserInfoInput,
  condition?: ModelUserInfoConditionInput | null,
};

export type DeleteUserInfoMutation = {
  deleteUserInfo?:  {
    __typename: "UserInfo",
    id: string,
    avatar?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    banner?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    displayName?: string | null,
    navigationAccuracy?: number | null,
    displayUnits?: DisplayUnits | null,
    socials?:  {
      __typename: "UserSocials",
      website?: string | null,
      facebook?: string | null,
      x?: string | null,
      blueSky?: string | null,
      instagram?: string | null,
    } | null,
    isTestAccount?: boolean | null,
    bio?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateUserFilterMutationVariables = {
  input: CreateUserFilterInput,
  condition?: ModelUserFilterConditionInput | null,
};

export type CreateUserFilterMutation = {
  createUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type UpdateUserFilterMutationVariables = {
  input: UpdateUserFilterInput,
  condition?: ModelUserFilterConditionInput | null,
};

export type UpdateUserFilterMutation = {
  updateUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type DeleteUserFilterMutationVariables = {
  input: DeleteUserFilterInput,
  condition?: ModelUserFilterConditionInput | null,
};

export type DeleteUserFilterMutation = {
  deleteUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type CreatePublicFilterMutationVariables = {
  input: CreatePublicFilterInput,
  condition?: ModelPublicFilterConditionInput | null,
};

export type CreatePublicFilterMutation = {
  createPublicFilter?:  {
    __typename: "PublicFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdatePublicFilterMutationVariables = {
  input: UpdatePublicFilterInput,
  condition?: ModelPublicFilterConditionInput | null,
};

export type UpdatePublicFilterMutation = {
  updatePublicFilter?:  {
    __typename: "PublicFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeletePublicFilterMutationVariables = {
  input: DeletePublicFilterInput,
  condition?: ModelPublicFilterConditionInput | null,
};

export type DeletePublicFilterMutation = {
  deletePublicFilter?:  {
    __typename: "PublicFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateModerationRequestMutationVariables = {
  input: CreateModerationRequestInput,
  condition?: ModelModerationRequestConditionInput | null,
};

export type CreateModerationRequestMutation = {
  createModerationRequest?:  {
    __typename: "ModerationRequest",
    id: string,
    anonymous?: boolean | null,
    payload: string,
    type: ModerationRequestType,
    status: ModerationStatus,
    groupAccess?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type UpdateModerationRequestMutationVariables = {
  input: UpdateModerationRequestInput,
  condition?: ModelModerationRequestConditionInput | null,
};

export type UpdateModerationRequestMutation = {
  updateModerationRequest?:  {
    __typename: "ModerationRequest",
    id: string,
    anonymous?: boolean | null,
    payload: string,
    type: ModerationRequestType,
    status: ModerationStatus,
    groupAccess?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type DeleteModerationRequestMutationVariables = {
  input: DeleteModerationRequestInput,
  condition?: ModelModerationRequestConditionInput | null,
};

export type DeleteModerationRequestMutation = {
  deleteModerationRequest?:  {
    __typename: "ModerationRequest",
    id: string,
    anonymous?: boolean | null,
    payload: string,
    type: ModerationRequestType,
    status: ModerationStatus,
    groupAccess?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type CreatePlaceListEntryMutationVariables = {
  input: CreatePlaceListEntryInput,
  condition?: ModelPlaceListEntryConditionInput | null,
};

export type CreatePlaceListEntryMutation = {
  createPlaceListEntry?:  {
    __typename: "PlaceListEntry",
    id: string,
    placeList?:  {
      __typename: "PlaceList",
      id: string,
      name: string,
      description?: string | null,
      entries?:  {
        __typename: "ModelPlaceListEntryConnection",
        items:  Array< {
          __typename: "PlaceListEntry",
          id: string,
          placeList?:  {
            __typename: "PlaceList",
            id: string,
            name: string,
            description?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            owner?: string | null,
          } | null,
          place: string,
          order: number,
          checked?: boolean | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeListEntriesId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null,
    place: string,
    order: number,
    checked?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeListEntriesId?: string | null,
    owner?: string | null,
  } | null,
};

export type UpdatePlaceListEntryMutationVariables = {
  input: UpdatePlaceListEntryInput,
  condition?: ModelPlaceListEntryConditionInput | null,
};

export type UpdatePlaceListEntryMutation = {
  updatePlaceListEntry?:  {
    __typename: "PlaceListEntry",
    id: string,
    placeList?:  {
      __typename: "PlaceList",
      id: string,
      name: string,
      description?: string | null,
      entries?:  {
        __typename: "ModelPlaceListEntryConnection",
        items:  Array< {
          __typename: "PlaceListEntry",
          id: string,
          placeList?:  {
            __typename: "PlaceList",
            id: string,
            name: string,
            description?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            owner?: string | null,
          } | null,
          place: string,
          order: number,
          checked?: boolean | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeListEntriesId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null,
    place: string,
    order: number,
    checked?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeListEntriesId?: string | null,
    owner?: string | null,
  } | null,
};

export type DeletePlaceListEntryMutationVariables = {
  input: DeletePlaceListEntryInput,
  condition?: ModelPlaceListEntryConditionInput | null,
};

export type DeletePlaceListEntryMutation = {
  deletePlaceListEntry?:  {
    __typename: "PlaceListEntry",
    id: string,
    placeList?:  {
      __typename: "PlaceList",
      id: string,
      name: string,
      description?: string | null,
      entries?:  {
        __typename: "ModelPlaceListEntryConnection",
        items:  Array< {
          __typename: "PlaceListEntry",
          id: string,
          placeList?:  {
            __typename: "PlaceList",
            id: string,
            name: string,
            description?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            owner?: string | null,
          } | null,
          place: string,
          order: number,
          checked?: boolean | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeListEntriesId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null,
    place: string,
    order: number,
    checked?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeListEntriesId?: string | null,
    owner?: string | null,
  } | null,
};

export type CreatePlaceListMutationVariables = {
  input: CreatePlaceListInput,
  condition?: ModelPlaceListConditionInput | null,
};

export type CreatePlaceListMutation = {
  createPlaceList?:  {
    __typename: "PlaceList",
    id: string,
    name: string,
    description?: string | null,
    entries?:  {
      __typename: "ModelPlaceListEntryConnection",
      items:  Array< {
        __typename: "PlaceListEntry",
        id: string,
        placeList?:  {
          __typename: "PlaceList",
          id: string,
          name: string,
          description?: string | null,
          entries?:  {
            __typename: "ModelPlaceListEntryConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          owner?: string | null,
        } | null,
        place: string,
        order: number,
        checked?: boolean | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeListEntriesId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type UpdatePlaceListMutationVariables = {
  input: UpdatePlaceListInput,
  condition?: ModelPlaceListConditionInput | null,
};

export type UpdatePlaceListMutation = {
  updatePlaceList?:  {
    __typename: "PlaceList",
    id: string,
    name: string,
    description?: string | null,
    entries?:  {
      __typename: "ModelPlaceListEntryConnection",
      items:  Array< {
        __typename: "PlaceListEntry",
        id: string,
        placeList?:  {
          __typename: "PlaceList",
          id: string,
          name: string,
          description?: string | null,
          entries?:  {
            __typename: "ModelPlaceListEntryConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          owner?: string | null,
        } | null,
        place: string,
        order: number,
        checked?: boolean | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeListEntriesId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type DeletePlaceListMutationVariables = {
  input: DeletePlaceListInput,
  condition?: ModelPlaceListConditionInput | null,
};

export type DeletePlaceListMutation = {
  deletePlaceList?:  {
    __typename: "PlaceList",
    id: string,
    name: string,
    description?: string | null,
    entries?:  {
      __typename: "ModelPlaceListEntryConnection",
      items:  Array< {
        __typename: "PlaceListEntry",
        id: string,
        placeList?:  {
          __typename: "PlaceList",
          id: string,
          name: string,
          description?: string | null,
          entries?:  {
            __typename: "ModelPlaceListEntryConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          owner?: string | null,
        } | null,
        place: string,
        order: number,
        checked?: boolean | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeListEntriesId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type GetWarningQueryVariables = {
  id: string,
};

export type GetWarningQuery = {
  getWarning?:  {
    __typename: "Warning",
    id: string,
    title: string,
    description: string,
    group: WarningGroup,
    level: WarningLevel,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListWarningsQueryVariables = {
  filter?: ModelWarningFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListWarningsQuery = {
  listWarnings?:  {
    __typename: "ModelWarningConnection",
    items:  Array< {
      __typename: "Warning",
      id: string,
      title: string,
      description: string,
      group: WarningGroup,
      level: WarningLevel,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncWarningsQueryVariables = {
  filter?: ModelWarningFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncWarningsQuery = {
  syncWarnings?:  {
    __typename: "ModelWarningConnection",
    items:  Array< {
      __typename: "Warning",
      id: string,
      title: string,
      description: string,
      group: WarningGroup,
      level: WarningLevel,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetGroundWaterQueryVariables = {
  id: string,
};

export type GetGroundWaterQuery = {
  getGroundWater?:  {
    __typename: "GroundWater",
    id: string,
    altitude: number,
    center:  {
      __typename: "LatLon",
      lat: number,
      lon: number,
    },
    radius: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type ListGroundWatersQueryVariables = {
  filter?: ModelGroundWaterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListGroundWatersQuery = {
  listGroundWaters?:  {
    __typename: "ModelGroundWaterConnection",
    items:  Array< {
      __typename: "GroundWater",
      id: string,
      altitude: number,
      center:  {
        __typename: "LatLon",
        lat: number,
        lon: number,
      },
      radius: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncGroundWatersQueryVariables = {
  filter?: ModelGroundWaterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncGroundWatersQuery = {
  syncGroundWaters?:  {
    __typename: "ModelGroundWaterConnection",
    items:  Array< {
      __typename: "GroundWater",
      id: string,
      altitude: number,
      center:  {
        __typename: "LatLon",
        lat: number,
        lon: number,
      },
      radius: number,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPlaceReportQueryVariables = {
  id: string,
};

export type GetPlaceReportQuery = {
  getPlaceReport?:  {
    __typename: "PlaceReport",
    owner?: string | null,
    id: string,
    rating: number,
    waterTemp?: number | null,
    visibility?: ReportVisibility | null,
    swell?: ReportSwell | null,
    wind?: ReportWind | null,
    text: string,
    date: string,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeReportsId?: string | null,
  } | null,
};

export type ListPlaceReportsQueryVariables = {
  filter?: ModelPlaceReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlaceReportsQuery = {
  listPlaceReports?:  {
    __typename: "ModelPlaceReportConnection",
    items:  Array< {
      __typename: "PlaceReport",
      owner?: string | null,
      id: string,
      rating: number,
      waterTemp?: number | null,
      visibility?: ReportVisibility | null,
      swell?: ReportSwell | null,
      wind?: ReportWind | null,
      text: string,
      date: string,
      place?:  {
        __typename: "Place",
        id: string,
        data:  {
          __typename: "PlaceData",
          name: string,
          alternateNames: Array< string >,
          location:  {
            __typename: "LatLon",
            lat: number,
            lon: number,
          },
          locationKnown: boolean,
          checked: boolean,
          checkedBy: string,
          spelioData:  {
            __typename: "SpelioData",
            systemName?: string | null,
            reference: string,
            source: string,
            type: LocationType,
            notes: string,
            caveRating: CaveRating,
            highestCaveRating?: CaveRating | null,
            tourismPotential: TourismPotential,
            accessDetails: string,
            verticalAccess: TriState,
            explorationPotential: ExplorationPotential,
            disabledAccessPotential: DisabledAccessPotential,
            files: Array< string >,
            labels: Array< string >,
            goesToWater: TriState,
            surveyedLength?: number | null,
          },
          diveData?:  {
            __typename: "DiveData",
            minDepth?: number | null,
            maxDepth?: number | null,
            waterType: WaterType,
            isTidal: TriState,
            minTemp?: number | null,
            maxTemp?: number | null,
            difficulty?: Difficulty | null,
            entryDifficulty?: Difficulty | null,
            entryType?: EntryType | null,
          } | null,
          wreckData?:  {
            __typename: "WreckData",
            type?: string | null,
            built?: string | null,
            dateSunk?: string | null,
            length?: number | null,
            width?: number | null,
            draught?: number | null,
          } | null,
          address?:  {
            __typename: "Address",
            streetNumber?: string | null,
            street?: string | null,
            suburb?: string | null,
            state?: string | null,
            country?: string | null,
            postcode?: string | null,
            timezone?: string | null,
          } | null,
          altitude?: number | null,
          warnings?: Array< string > | null,
          amenities?:  {
            __typename: "Amenities",
            hasShowers: TriState,
            hasToilets: TriState,
            hasPhone?: TriState | null,
            food?: Rating | null,
            family?: Rating | null,
            parking?: Rating | null,
          } | null,
        },
        userAccess?: Array< string > | null,
        groupAccess?: Array< string > | null,
        reports?:  {
          __typename: "ModelPlaceReportConnection",
          items:  Array< {
            __typename: "PlaceReport",
            owner?: string | null,
            id: string,
            rating: number,
            waterTemp?: number | null,
            visibility?: ReportVisibility | null,
            swell?: ReportSwell | null,
            wind?: ReportWind | null,
            text: string,
            date: string,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            placeReportsId?: string | null,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        ratings?:  {
          __typename: "ModelPlaceRatingConnection",
          items:  Array< {
            __typename: "PlaceRating",
            id: string,
            rating: number,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            placeRatingsId?: string | null,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        media?:  {
          __typename: "ModelPlaceMediaItemConnection",
          items:  Array< {
            __typename: "PlaceMediaItem",
            id: string,
            owner?: string | null,
            groupAccess?: Array< string > | null,
            placeMediaId?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        softDeleted?: string | null,
        scubaCollection?: string | null,
        caveCollection?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      placeReportsId?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPlaceReportsQueryVariables = {
  filter?: ModelPlaceReportFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPlaceReportsQuery = {
  syncPlaceReports?:  {
    __typename: "ModelPlaceReportConnection",
    items:  Array< {
      __typename: "PlaceReport",
      owner?: string | null,
      id: string,
      rating: number,
      waterTemp?: number | null,
      visibility?: ReportVisibility | null,
      swell?: ReportSwell | null,
      wind?: ReportWind | null,
      text: string,
      date: string,
      place?:  {
        __typename: "Place",
        id: string,
        data:  {
          __typename: "PlaceData",
          name: string,
          alternateNames: Array< string >,
          location:  {
            __typename: "LatLon",
            lat: number,
            lon: number,
          },
          locationKnown: boolean,
          checked: boolean,
          checkedBy: string,
          spelioData:  {
            __typename: "SpelioData",
            systemName?: string | null,
            reference: string,
            source: string,
            type: LocationType,
            notes: string,
            caveRating: CaveRating,
            highestCaveRating?: CaveRating | null,
            tourismPotential: TourismPotential,
            accessDetails: string,
            verticalAccess: TriState,
            explorationPotential: ExplorationPotential,
            disabledAccessPotential: DisabledAccessPotential,
            files: Array< string >,
            labels: Array< string >,
            goesToWater: TriState,
            surveyedLength?: number | null,
          },
          diveData?:  {
            __typename: "DiveData",
            minDepth?: number | null,
            maxDepth?: number | null,
            waterType: WaterType,
            isTidal: TriState,
            minTemp?: number | null,
            maxTemp?: number | null,
            difficulty?: Difficulty | null,
            entryDifficulty?: Difficulty | null,
            entryType?: EntryType | null,
          } | null,
          wreckData?:  {
            __typename: "WreckData",
            type?: string | null,
            built?: string | null,
            dateSunk?: string | null,
            length?: number | null,
            width?: number | null,
            draught?: number | null,
          } | null,
          address?:  {
            __typename: "Address",
            streetNumber?: string | null,
            street?: string | null,
            suburb?: string | null,
            state?: string | null,
            country?: string | null,
            postcode?: string | null,
            timezone?: string | null,
          } | null,
          altitude?: number | null,
          warnings?: Array< string > | null,
          amenities?:  {
            __typename: "Amenities",
            hasShowers: TriState,
            hasToilets: TriState,
            hasPhone?: TriState | null,
            food?: Rating | null,
            family?: Rating | null,
            parking?: Rating | null,
          } | null,
        },
        userAccess?: Array< string > | null,
        groupAccess?: Array< string > | null,
        reports?:  {
          __typename: "ModelPlaceReportConnection",
          items:  Array< {
            __typename: "PlaceReport",
            owner?: string | null,
            id: string,
            rating: number,
            waterTemp?: number | null,
            visibility?: ReportVisibility | null,
            swell?: ReportSwell | null,
            wind?: ReportWind | null,
            text: string,
            date: string,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            placeReportsId?: string | null,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        ratings?:  {
          __typename: "ModelPlaceRatingConnection",
          items:  Array< {
            __typename: "PlaceRating",
            id: string,
            rating: number,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            placeRatingsId?: string | null,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        media?:  {
          __typename: "ModelPlaceMediaItemConnection",
          items:  Array< {
            __typename: "PlaceMediaItem",
            id: string,
            owner?: string | null,
            groupAccess?: Array< string > | null,
            placeMediaId?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        softDeleted?: string | null,
        scubaCollection?: string | null,
        caveCollection?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      placeReportsId?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPlaceRatingQueryVariables = {
  id: string,
};

export type GetPlaceRatingQuery = {
  getPlaceRating?:  {
    __typename: "PlaceRating",
    id: string,
    rating: number,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeRatingsId?: string | null,
    owner?: string | null,
  } | null,
};

export type ListPlaceRatingsQueryVariables = {
  filter?: ModelPlaceRatingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlaceRatingsQuery = {
  listPlaceRatings?:  {
    __typename: "ModelPlaceRatingConnection",
    items:  Array< {
      __typename: "PlaceRating",
      id: string,
      rating: number,
      place?:  {
        __typename: "Place",
        id: string,
        data:  {
          __typename: "PlaceData",
          name: string,
          alternateNames: Array< string >,
          location:  {
            __typename: "LatLon",
            lat: number,
            lon: number,
          },
          locationKnown: boolean,
          checked: boolean,
          checkedBy: string,
          spelioData:  {
            __typename: "SpelioData",
            systemName?: string | null,
            reference: string,
            source: string,
            type: LocationType,
            notes: string,
            caveRating: CaveRating,
            highestCaveRating?: CaveRating | null,
            tourismPotential: TourismPotential,
            accessDetails: string,
            verticalAccess: TriState,
            explorationPotential: ExplorationPotential,
            disabledAccessPotential: DisabledAccessPotential,
            files: Array< string >,
            labels: Array< string >,
            goesToWater: TriState,
            surveyedLength?: number | null,
          },
          diveData?:  {
            __typename: "DiveData",
            minDepth?: number | null,
            maxDepth?: number | null,
            waterType: WaterType,
            isTidal: TriState,
            minTemp?: number | null,
            maxTemp?: number | null,
            difficulty?: Difficulty | null,
            entryDifficulty?: Difficulty | null,
            entryType?: EntryType | null,
          } | null,
          wreckData?:  {
            __typename: "WreckData",
            type?: string | null,
            built?: string | null,
            dateSunk?: string | null,
            length?: number | null,
            width?: number | null,
            draught?: number | null,
          } | null,
          address?:  {
            __typename: "Address",
            streetNumber?: string | null,
            street?: string | null,
            suburb?: string | null,
            state?: string | null,
            country?: string | null,
            postcode?: string | null,
            timezone?: string | null,
          } | null,
          altitude?: number | null,
          warnings?: Array< string > | null,
          amenities?:  {
            __typename: "Amenities",
            hasShowers: TriState,
            hasToilets: TriState,
            hasPhone?: TriState | null,
            food?: Rating | null,
            family?: Rating | null,
            parking?: Rating | null,
          } | null,
        },
        userAccess?: Array< string > | null,
        groupAccess?: Array< string > | null,
        reports?:  {
          __typename: "ModelPlaceReportConnection",
          items:  Array< {
            __typename: "PlaceReport",
            owner?: string | null,
            id: string,
            rating: number,
            waterTemp?: number | null,
            visibility?: ReportVisibility | null,
            swell?: ReportSwell | null,
            wind?: ReportWind | null,
            text: string,
            date: string,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            placeReportsId?: string | null,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        ratings?:  {
          __typename: "ModelPlaceRatingConnection",
          items:  Array< {
            __typename: "PlaceRating",
            id: string,
            rating: number,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            placeRatingsId?: string | null,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        media?:  {
          __typename: "ModelPlaceMediaItemConnection",
          items:  Array< {
            __typename: "PlaceMediaItem",
            id: string,
            owner?: string | null,
            groupAccess?: Array< string > | null,
            placeMediaId?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        softDeleted?: string | null,
        scubaCollection?: string | null,
        caveCollection?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      placeRatingsId?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPlaceRatingsQueryVariables = {
  filter?: ModelPlaceRatingFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPlaceRatingsQuery = {
  syncPlaceRatings?:  {
    __typename: "ModelPlaceRatingConnection",
    items:  Array< {
      __typename: "PlaceRating",
      id: string,
      rating: number,
      place?:  {
        __typename: "Place",
        id: string,
        data:  {
          __typename: "PlaceData",
          name: string,
          alternateNames: Array< string >,
          location:  {
            __typename: "LatLon",
            lat: number,
            lon: number,
          },
          locationKnown: boolean,
          checked: boolean,
          checkedBy: string,
          spelioData:  {
            __typename: "SpelioData",
            systemName?: string | null,
            reference: string,
            source: string,
            type: LocationType,
            notes: string,
            caveRating: CaveRating,
            highestCaveRating?: CaveRating | null,
            tourismPotential: TourismPotential,
            accessDetails: string,
            verticalAccess: TriState,
            explorationPotential: ExplorationPotential,
            disabledAccessPotential: DisabledAccessPotential,
            files: Array< string >,
            labels: Array< string >,
            goesToWater: TriState,
            surveyedLength?: number | null,
          },
          diveData?:  {
            __typename: "DiveData",
            minDepth?: number | null,
            maxDepth?: number | null,
            waterType: WaterType,
            isTidal: TriState,
            minTemp?: number | null,
            maxTemp?: number | null,
            difficulty?: Difficulty | null,
            entryDifficulty?: Difficulty | null,
            entryType?: EntryType | null,
          } | null,
          wreckData?:  {
            __typename: "WreckData",
            type?: string | null,
            built?: string | null,
            dateSunk?: string | null,
            length?: number | null,
            width?: number | null,
            draught?: number | null,
          } | null,
          address?:  {
            __typename: "Address",
            streetNumber?: string | null,
            street?: string | null,
            suburb?: string | null,
            state?: string | null,
            country?: string | null,
            postcode?: string | null,
            timezone?: string | null,
          } | null,
          altitude?: number | null,
          warnings?: Array< string > | null,
          amenities?:  {
            __typename: "Amenities",
            hasShowers: TriState,
            hasToilets: TriState,
            hasPhone?: TriState | null,
            food?: Rating | null,
            family?: Rating | null,
            parking?: Rating | null,
          } | null,
        },
        userAccess?: Array< string > | null,
        groupAccess?: Array< string > | null,
        reports?:  {
          __typename: "ModelPlaceReportConnection",
          items:  Array< {
            __typename: "PlaceReport",
            owner?: string | null,
            id: string,
            rating: number,
            waterTemp?: number | null,
            visibility?: ReportVisibility | null,
            swell?: ReportSwell | null,
            wind?: ReportWind | null,
            text: string,
            date: string,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            placeReportsId?: string | null,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        ratings?:  {
          __typename: "ModelPlaceRatingConnection",
          items:  Array< {
            __typename: "PlaceRating",
            id: string,
            rating: number,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            placeRatingsId?: string | null,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        media?:  {
          __typename: "ModelPlaceMediaItemConnection",
          items:  Array< {
            __typename: "PlaceMediaItem",
            id: string,
            owner?: string | null,
            groupAccess?: Array< string > | null,
            placeMediaId?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        softDeleted?: string | null,
        scubaCollection?: string | null,
        caveCollection?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      placeRatingsId?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPlaceMediaItemQueryVariables = {
  id: string,
};

export type GetPlaceMediaItemQuery = {
  getPlaceMediaItem?:  {
    __typename: "PlaceMediaItem",
    id: string,
    owner?: string | null,
    groupAccess?: Array< string > | null,
    media?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    placeMediaId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListPlaceMediaItemsQueryVariables = {
  filter?: ModelPlaceMediaItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlaceMediaItemsQuery = {
  listPlaceMediaItems?:  {
    __typename: "ModelPlaceMediaItemConnection",
    items:  Array< {
      __typename: "PlaceMediaItem",
      id: string,
      owner?: string | null,
      groupAccess?: Array< string > | null,
      media?:  {
        __typename: "Media",
        id: string,
        contributorId?: string | null,
        mimeType: string,
        file:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail_256px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_512px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_1024px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        name?: string | null,
        description?: string | null,
        contentType?: MediaContentType | null,
        attribution?: string | null,
        attributionLink?: string | null,
        dateAdded?: string | null,
        dateCreated?: string | null,
      } | null,
      placeMediaId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPlaceMediaItemsQueryVariables = {
  filter?: ModelPlaceMediaItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPlaceMediaItemsQuery = {
  syncPlaceMediaItems?:  {
    __typename: "ModelPlaceMediaItemConnection",
    items:  Array< {
      __typename: "PlaceMediaItem",
      id: string,
      owner?: string | null,
      groupAccess?: Array< string > | null,
      media?:  {
        __typename: "Media",
        id: string,
        contributorId?: string | null,
        mimeType: string,
        file:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail_256px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_512px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_1024px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        name?: string | null,
        description?: string | null,
        contentType?: MediaContentType | null,
        attribution?: string | null,
        attributionLink?: string | null,
        dateAdded?: string | null,
        dateCreated?: string | null,
      } | null,
      placeMediaId?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPlaceQueryVariables = {
  id: string,
};

export type GetPlaceQuery = {
  getPlace?:  {
    __typename: "Place",
    id: string,
    data:  {
      __typename: "PlaceData",
      name: string,
      alternateNames: Array< string >,
      location:  {
        __typename: "LatLon",
        lat: number,
        lon: number,
      },
      locationKnown: boolean,
      checked: boolean,
      checkedBy: string,
      spelioData:  {
        __typename: "SpelioData",
        systemName?: string | null,
        reference: string,
        source: string,
        type: LocationType,
        notes: string,
        caveRating: CaveRating,
        highestCaveRating?: CaveRating | null,
        tourismPotential: TourismPotential,
        accessDetails: string,
        verticalAccess: TriState,
        explorationPotential: ExplorationPotential,
        disabledAccessPotential: DisabledAccessPotential,
        files: Array< string >,
        labels: Array< string >,
        goesToWater: TriState,
        references:  Array< {
          __typename: "Reference",
          name: string,
          text: string,
        } >,
        surveyedLength?: number | null,
      },
      diveData?:  {
        __typename: "DiveData",
        minDepth?: number | null,
        maxDepth?: number | null,
        waterType: WaterType,
        isTidal: TriState,
        minTemp?: number | null,
        maxTemp?: number | null,
        difficulty?: Difficulty | null,
        entryDifficulty?: Difficulty | null,
        entryType?: EntryType | null,
      } | null,
      wreckData?:  {
        __typename: "WreckData",
        type?: string | null,
        built?: string | null,
        dateSunk?: string | null,
        length?: number | null,
        width?: number | null,
        draught?: number | null,
      } | null,
      address?:  {
        __typename: "Address",
        streetNumber?: string | null,
        street?: string | null,
        suburb?: string | null,
        state?: string | null,
        country?: string | null,
        postcode?: string | null,
        timezone?: string | null,
      } | null,
      altitude?: number | null,
      warnings?: Array< string > | null,
      amenities?:  {
        __typename: "Amenities",
        hasShowers: TriState,
        hasToilets: TriState,
        hasPhone?: TriState | null,
        food?: Rating | null,
        family?: Rating | null,
        parking?: Rating | null,
      } | null,
    },
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    reports?:  {
      __typename: "ModelPlaceReportConnection",
      items:  Array< {
        __typename: "PlaceReport",
        owner?: string | null,
        id: string,
        rating: number,
        waterTemp?: number | null,
        visibility?: ReportVisibility | null,
        swell?: ReportSwell | null,
        wind?: ReportWind | null,
        text: string,
        date: string,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeReportsId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    ratings?:  {
      __typename: "ModelPlaceRatingConnection",
      items:  Array< {
        __typename: "PlaceRating",
        id: string,
        rating: number,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeRatingsId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    media?:  {
      __typename: "ModelPlaceMediaItemConnection",
      items:  Array< {
        __typename: "PlaceMediaItem",
        id: string,
        owner?: string | null,
        groupAccess?: Array< string > | null,
        media?:  {
          __typename: "Media",
          id: string,
          contributorId?: string | null,
          mimeType: string,
          file:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail_256px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_512px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_1024px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          name?: string | null,
          description?: string | null,
          contentType?: MediaContentType | null,
          attribution?: string | null,
          attributionLink?: string | null,
          dateAdded?: string | null,
          dateCreated?: string | null,
        } | null,
        placeMediaId?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    softDeleted?: string | null,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListPlacesQueryVariables = {
  filter?: ModelPlaceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlacesQuery = {
  listPlaces?:  {
    __typename: "ModelPlaceConnection",
    items:  Array< {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPlacesQueryVariables = {
  filter?: ModelPlaceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPlacesQuery = {
  syncPlaces?:  {
    __typename: "ModelPlaceConnection",
    items:  Array< {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type PlaceBySoftDeletedQueryVariables = {
  softDeleted: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPlaceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PlaceBySoftDeletedQuery = {
  placeBySoftDeleted?:  {
    __typename: "ModelPlaceConnection",
    items:  Array< {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type PlaceByScubaCollectionQueryVariables = {
  scubaCollection: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPlaceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PlaceByScubaCollectionQuery = {
  placeByScubaCollection?:  {
    __typename: "ModelPlaceConnection",
    items:  Array< {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type PlaceByCaveCollectionQueryVariables = {
  caveCollection: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelPlaceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PlaceByCaveCollectionQuery = {
  placeByCaveCollection?:  {
    __typename: "ModelPlaceConnection",
    items:  Array< {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetJournalQueryVariables = {
  id: string,
};

export type GetJournalQuery = {
  getJournal?:  {
    __typename: "Journal",
    id: string,
    addedAt: string,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    modifications:  Array< {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } >,
    modification?:  {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } | null,
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    contributor?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListJournalsQueryVariables = {
  filter?: ModelJournalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListJournalsQuery = {
  listJournals?:  {
    __typename: "ModelJournalConnection",
    items:  Array< {
      __typename: "Journal",
      id: string,
      addedAt: string,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      modifications:  Array< {
        __typename: "Modification",
        action: ModificationAction,
        model: ModificationModel,
        modelId: string,
        modelName: string,
        detail: string,
        collections?: string | null,
      } >,
      modification?:  {
        __typename: "Modification",
        action: ModificationAction,
        model: ModificationModel,
        modelId: string,
        modelName: string,
        detail: string,
        collections?: string | null,
      } | null,
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      contributor?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncJournalsQueryVariables = {
  filter?: ModelJournalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncJournalsQuery = {
  syncJournals?:  {
    __typename: "ModelJournalConnection",
    items:  Array< {
      __typename: "Journal",
      id: string,
      addedAt: string,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      modifications:  Array< {
        __typename: "Modification",
        action: ModificationAction,
        model: ModificationModel,
        modelId: string,
        modelName: string,
        detail: string,
        collections?: string | null,
      } >,
      modification?:  {
        __typename: "Modification",
        action: ModificationAction,
        model: ModificationModel,
        modelId: string,
        modelName: string,
        detail: string,
        collections?: string | null,
      } | null,
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      contributor?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type JournalByAddedAtQueryVariables = {
  addedAt: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelJournalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type JournalByAddedAtQuery = {
  journalByAddedAt?:  {
    __typename: "ModelJournalConnection",
    items:  Array< {
      __typename: "Journal",
      id: string,
      addedAt: string,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      modifications:  Array< {
        __typename: "Modification",
        action: ModificationAction,
        model: ModificationModel,
        modelId: string,
        modelName: string,
        detail: string,
        collections?: string | null,
      } >,
      modification?:  {
        __typename: "Modification",
        action: ModificationAction,
        model: ModificationModel,
        modelId: string,
        modelName: string,
        detail: string,
        collections?: string | null,
      } | null,
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      contributor?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type JournalByScubaCollectionQueryVariables = {
  scubaCollection: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelJournalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type JournalByScubaCollectionQuery = {
  journalByScubaCollection?:  {
    __typename: "ModelJournalConnection",
    items:  Array< {
      __typename: "Journal",
      id: string,
      addedAt: string,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      modifications:  Array< {
        __typename: "Modification",
        action: ModificationAction,
        model: ModificationModel,
        modelId: string,
        modelName: string,
        detail: string,
        collections?: string | null,
      } >,
      modification?:  {
        __typename: "Modification",
        action: ModificationAction,
        model: ModificationModel,
        modelId: string,
        modelName: string,
        detail: string,
        collections?: string | null,
      } | null,
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      contributor?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type JournalByCaveCollectionQueryVariables = {
  caveCollection: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelJournalFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type JournalByCaveCollectionQuery = {
  journalByCaveCollection?:  {
    __typename: "ModelJournalConnection",
    items:  Array< {
      __typename: "Journal",
      id: string,
      addedAt: string,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      modifications:  Array< {
        __typename: "Modification",
        action: ModificationAction,
        model: ModificationModel,
        modelId: string,
        modelName: string,
        detail: string,
        collections?: string | null,
      } >,
      modification?:  {
        __typename: "Modification",
        action: ModificationAction,
        model: ModificationModel,
        modelId: string,
        modelName: string,
        detail: string,
        collections?: string | null,
      } | null,
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      contributor?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserInfoQueryVariables = {
  id: string,
};

export type GetUserInfoQuery = {
  getUserInfo?:  {
    __typename: "UserInfo",
    id: string,
    avatar?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    banner?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    displayName?: string | null,
    navigationAccuracy?: number | null,
    displayUnits?: DisplayUnits | null,
    socials?:  {
      __typename: "UserSocials",
      website?: string | null,
      facebook?: string | null,
      x?: string | null,
      blueSky?: string | null,
      instagram?: string | null,
    } | null,
    isTestAccount?: boolean | null,
    bio?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListUserInfosQueryVariables = {
  filter?: ModelUserInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserInfosQuery = {
  listUserInfos?:  {
    __typename: "ModelUserInfoConnection",
    items:  Array< {
      __typename: "UserInfo",
      id: string,
      avatar?:  {
        __typename: "Media",
        id: string,
        contributorId?: string | null,
        mimeType: string,
        file:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail_256px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_512px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_1024px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        name?: string | null,
        description?: string | null,
        contentType?: MediaContentType | null,
        attribution?: string | null,
        attributionLink?: string | null,
        dateAdded?: string | null,
        dateCreated?: string | null,
      } | null,
      banner?:  {
        __typename: "Media",
        id: string,
        contributorId?: string | null,
        mimeType: string,
        file:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail_256px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_512px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_1024px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        name?: string | null,
        description?: string | null,
        contentType?: MediaContentType | null,
        attribution?: string | null,
        attributionLink?: string | null,
        dateAdded?: string | null,
        dateCreated?: string | null,
      } | null,
      displayName?: string | null,
      navigationAccuracy?: number | null,
      displayUnits?: DisplayUnits | null,
      socials?:  {
        __typename: "UserSocials",
        website?: string | null,
        facebook?: string | null,
        x?: string | null,
        blueSky?: string | null,
        instagram?: string | null,
      } | null,
      isTestAccount?: boolean | null,
      bio?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUserInfosQueryVariables = {
  filter?: ModelUserInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUserInfosQuery = {
  syncUserInfos?:  {
    __typename: "ModelUserInfoConnection",
    items:  Array< {
      __typename: "UserInfo",
      id: string,
      avatar?:  {
        __typename: "Media",
        id: string,
        contributorId?: string | null,
        mimeType: string,
        file:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail_256px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_512px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_1024px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        name?: string | null,
        description?: string | null,
        contentType?: MediaContentType | null,
        attribution?: string | null,
        attributionLink?: string | null,
        dateAdded?: string | null,
        dateCreated?: string | null,
      } | null,
      banner?:  {
        __typename: "Media",
        id: string,
        contributorId?: string | null,
        mimeType: string,
        file:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail_256px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_512px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_1024px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        name?: string | null,
        description?: string | null,
        contentType?: MediaContentType | null,
        attribution?: string | null,
        attributionLink?: string | null,
        dateAdded?: string | null,
        dateCreated?: string | null,
      } | null,
      displayName?: string | null,
      navigationAccuracy?: number | null,
      displayUnits?: DisplayUnits | null,
      socials?:  {
        __typename: "UserSocials",
        website?: string | null,
        facebook?: string | null,
        x?: string | null,
        blueSky?: string | null,
        instagram?: string | null,
      } | null,
      isTestAccount?: boolean | null,
      bio?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type UserInfoByOwnerQueryVariables = {
  owner: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelUserInfoFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UserInfoByOwnerQuery = {
  userInfoByOwner?:  {
    __typename: "ModelUserInfoConnection",
    items:  Array< {
      __typename: "UserInfo",
      id: string,
      avatar?:  {
        __typename: "Media",
        id: string,
        contributorId?: string | null,
        mimeType: string,
        file:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail_256px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_512px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_1024px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        name?: string | null,
        description?: string | null,
        contentType?: MediaContentType | null,
        attribution?: string | null,
        attributionLink?: string | null,
        dateAdded?: string | null,
        dateCreated?: string | null,
      } | null,
      banner?:  {
        __typename: "Media",
        id: string,
        contributorId?: string | null,
        mimeType: string,
        file:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        },
        thumbnail_256px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_512px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        thumbnail_1024px?:  {
          __typename: "S3Object",
          bucket: string,
          region: string,
          key: string,
        } | null,
        name?: string | null,
        description?: string | null,
        contentType?: MediaContentType | null,
        attribution?: string | null,
        attributionLink?: string | null,
        dateAdded?: string | null,
        dateCreated?: string | null,
      } | null,
      displayName?: string | null,
      navigationAccuracy?: number | null,
      displayUnits?: DisplayUnits | null,
      socials?:  {
        __typename: "UserSocials",
        website?: string | null,
        facebook?: string | null,
        x?: string | null,
        blueSky?: string | null,
        instagram?: string | null,
      } | null,
      isTestAccount?: boolean | null,
      bio?: string | null,
      owner?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetUserFilterQueryVariables = {
  id: string,
};

export type GetUserFilterQuery = {
  getUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type ListUserFiltersQueryVariables = {
  filter?: ModelUserFilterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListUserFiltersQuery = {
  listUserFilters?:  {
    __typename: "ModelUserFilterConnection",
    items:  Array< {
      __typename: "UserFilter",
      id: string,
      name: string,
      filterVersion: number,
      filter: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncUserFiltersQueryVariables = {
  filter?: ModelUserFilterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncUserFiltersQuery = {
  syncUserFilters?:  {
    __typename: "ModelUserFilterConnection",
    items:  Array< {
      __typename: "UserFilter",
      id: string,
      name: string,
      filterVersion: number,
      filter: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPublicFilterQueryVariables = {
  id: string,
};

export type GetPublicFilterQuery = {
  getPublicFilter?:  {
    __typename: "PublicFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListPublicFiltersQueryVariables = {
  filter?: ModelPublicFilterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPublicFiltersQuery = {
  listPublicFilters?:  {
    __typename: "ModelPublicFilterConnection",
    items:  Array< {
      __typename: "PublicFilter",
      id: string,
      name: string,
      filterVersion: number,
      filter: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPublicFiltersQueryVariables = {
  filter?: ModelPublicFilterFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPublicFiltersQuery = {
  syncPublicFilters?:  {
    __typename: "ModelPublicFilterConnection",
    items:  Array< {
      __typename: "PublicFilter",
      id: string,
      name: string,
      filterVersion: number,
      filter: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetModerationRequestQueryVariables = {
  id: string,
};

export type GetModerationRequestQuery = {
  getModerationRequest?:  {
    __typename: "ModerationRequest",
    id: string,
    anonymous?: boolean | null,
    payload: string,
    type: ModerationRequestType,
    status: ModerationStatus,
    groupAccess?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type ListModerationRequestsQueryVariables = {
  filter?: ModelModerationRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListModerationRequestsQuery = {
  listModerationRequests?:  {
    __typename: "ModelModerationRequestConnection",
    items:  Array< {
      __typename: "ModerationRequest",
      id: string,
      anonymous?: boolean | null,
      payload: string,
      type: ModerationRequestType,
      status: ModerationStatus,
      groupAccess?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncModerationRequestsQueryVariables = {
  filter?: ModelModerationRequestFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncModerationRequestsQuery = {
  syncModerationRequests?:  {
    __typename: "ModelModerationRequestConnection",
    items:  Array< {
      __typename: "ModerationRequest",
      id: string,
      anonymous?: boolean | null,
      payload: string,
      type: ModerationRequestType,
      status: ModerationStatus,
      groupAccess?: Array< string > | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPlaceListEntryQueryVariables = {
  id: string,
};

export type GetPlaceListEntryQuery = {
  getPlaceListEntry?:  {
    __typename: "PlaceListEntry",
    id: string,
    placeList?:  {
      __typename: "PlaceList",
      id: string,
      name: string,
      description?: string | null,
      entries?:  {
        __typename: "ModelPlaceListEntryConnection",
        items:  Array< {
          __typename: "PlaceListEntry",
          id: string,
          placeList?:  {
            __typename: "PlaceList",
            id: string,
            name: string,
            description?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            owner?: string | null,
          } | null,
          place: string,
          order: number,
          checked?: boolean | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeListEntriesId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null,
    place: string,
    order: number,
    checked?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeListEntriesId?: string | null,
    owner?: string | null,
  } | null,
};

export type ListPlaceListEntriesQueryVariables = {
  filter?: ModelPlaceListEntryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlaceListEntriesQuery = {
  listPlaceListEntries?:  {
    __typename: "ModelPlaceListEntryConnection",
    items:  Array< {
      __typename: "PlaceListEntry",
      id: string,
      placeList?:  {
        __typename: "PlaceList",
        id: string,
        name: string,
        description?: string | null,
        entries?:  {
          __typename: "ModelPlaceListEntryConnection",
          items:  Array< {
            __typename: "PlaceListEntry",
            id: string,
            place: string,
            order: number,
            checked?: boolean | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            placeListEntriesId?: string | null,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        owner?: string | null,
      } | null,
      place: string,
      order: number,
      checked?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      placeListEntriesId?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPlaceListEntriesQueryVariables = {
  filter?: ModelPlaceListEntryFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPlaceListEntriesQuery = {
  syncPlaceListEntries?:  {
    __typename: "ModelPlaceListEntryConnection",
    items:  Array< {
      __typename: "PlaceListEntry",
      id: string,
      placeList?:  {
        __typename: "PlaceList",
        id: string,
        name: string,
        description?: string | null,
        entries?:  {
          __typename: "ModelPlaceListEntryConnection",
          items:  Array< {
            __typename: "PlaceListEntry",
            id: string,
            place: string,
            order: number,
            checked?: boolean | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            placeListEntriesId?: string | null,
            owner?: string | null,
          } | null >,
          nextToken?: string | null,
          startedAt?: number | null,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        owner?: string | null,
      } | null,
      place: string,
      order: number,
      checked?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      placeListEntriesId?: string | null,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetPlaceListQueryVariables = {
  id: string,
};

export type GetPlaceListQuery = {
  getPlaceList?:  {
    __typename: "PlaceList",
    id: string,
    name: string,
    description?: string | null,
    entries?:  {
      __typename: "ModelPlaceListEntryConnection",
      items:  Array< {
        __typename: "PlaceListEntry",
        id: string,
        placeList?:  {
          __typename: "PlaceList",
          id: string,
          name: string,
          description?: string | null,
          entries?:  {
            __typename: "ModelPlaceListEntryConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          owner?: string | null,
        } | null,
        place: string,
        order: number,
        checked?: boolean | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeListEntriesId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type ListPlaceListsQueryVariables = {
  filter?: ModelPlaceListFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListPlaceListsQuery = {
  listPlaceLists?:  {
    __typename: "ModelPlaceListConnection",
    items:  Array< {
      __typename: "PlaceList",
      id: string,
      name: string,
      description?: string | null,
      entries?:  {
        __typename: "ModelPlaceListEntryConnection",
        items:  Array< {
          __typename: "PlaceListEntry",
          id: string,
          placeList?:  {
            __typename: "PlaceList",
            id: string,
            name: string,
            description?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            owner?: string | null,
          } | null,
          place: string,
          order: number,
          checked?: boolean | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeListEntriesId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncPlaceListsQueryVariables = {
  filter?: ModelPlaceListFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncPlaceListsQuery = {
  syncPlaceLists?:  {
    __typename: "ModelPlaceListConnection",
    items:  Array< {
      __typename: "PlaceList",
      id: string,
      name: string,
      description?: string | null,
      entries?:  {
        __typename: "ModelPlaceListEntryConnection",
        items:  Array< {
          __typename: "PlaceListEntry",
          id: string,
          placeList?:  {
            __typename: "PlaceList",
            id: string,
            name: string,
            description?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            owner?: string | null,
          } | null,
          place: string,
          order: number,
          checked?: boolean | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeListEntriesId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type OnCreateWarningSubscriptionVariables = {
  filter?: ModelSubscriptionWarningFilterInput | null,
};

export type OnCreateWarningSubscription = {
  onCreateWarning?:  {
    __typename: "Warning",
    id: string,
    title: string,
    description: string,
    group: WarningGroup,
    level: WarningLevel,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateWarningSubscriptionVariables = {
  filter?: ModelSubscriptionWarningFilterInput | null,
};

export type OnUpdateWarningSubscription = {
  onUpdateWarning?:  {
    __typename: "Warning",
    id: string,
    title: string,
    description: string,
    group: WarningGroup,
    level: WarningLevel,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteWarningSubscriptionVariables = {
  filter?: ModelSubscriptionWarningFilterInput | null,
};

export type OnDeleteWarningSubscription = {
  onDeleteWarning?:  {
    __typename: "Warning",
    id: string,
    title: string,
    description: string,
    group: WarningGroup,
    level: WarningLevel,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateGroundWaterSubscriptionVariables = {
  filter?: ModelSubscriptionGroundWaterFilterInput | null,
  owner?: string | null,
};

export type OnCreateGroundWaterSubscription = {
  onCreateGroundWater?:  {
    __typename: "GroundWater",
    id: string,
    altitude: number,
    center:  {
      __typename: "LatLon",
      lat: number,
      lon: number,
    },
    radius: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type OnUpdateGroundWaterSubscriptionVariables = {
  filter?: ModelSubscriptionGroundWaterFilterInput | null,
  owner?: string | null,
};

export type OnUpdateGroundWaterSubscription = {
  onUpdateGroundWater?:  {
    __typename: "GroundWater",
    id: string,
    altitude: number,
    center:  {
      __typename: "LatLon",
      lat: number,
      lon: number,
    },
    radius: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type OnDeleteGroundWaterSubscriptionVariables = {
  filter?: ModelSubscriptionGroundWaterFilterInput | null,
  owner?: string | null,
};

export type OnDeleteGroundWaterSubscription = {
  onDeleteGroundWater?:  {
    __typename: "GroundWater",
    id: string,
    altitude: number,
    center:  {
      __typename: "LatLon",
      lat: number,
      lon: number,
    },
    radius: number,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type OnCreatePlaceReportSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceReportFilterInput | null,
  owner?: string | null,
};

export type OnCreatePlaceReportSubscription = {
  onCreatePlaceReport?:  {
    __typename: "PlaceReport",
    owner?: string | null,
    id: string,
    rating: number,
    waterTemp?: number | null,
    visibility?: ReportVisibility | null,
    swell?: ReportSwell | null,
    wind?: ReportWind | null,
    text: string,
    date: string,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeReportsId?: string | null,
  } | null,
};

export type OnUpdatePlaceReportSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceReportFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePlaceReportSubscription = {
  onUpdatePlaceReport?:  {
    __typename: "PlaceReport",
    owner?: string | null,
    id: string,
    rating: number,
    waterTemp?: number | null,
    visibility?: ReportVisibility | null,
    swell?: ReportSwell | null,
    wind?: ReportWind | null,
    text: string,
    date: string,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeReportsId?: string | null,
  } | null,
};

export type OnDeletePlaceReportSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceReportFilterInput | null,
  owner?: string | null,
};

export type OnDeletePlaceReportSubscription = {
  onDeletePlaceReport?:  {
    __typename: "PlaceReport",
    owner?: string | null,
    id: string,
    rating: number,
    waterTemp?: number | null,
    visibility?: ReportVisibility | null,
    swell?: ReportSwell | null,
    wind?: ReportWind | null,
    text: string,
    date: string,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeReportsId?: string | null,
  } | null,
};

export type OnCreatePlaceRatingSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceRatingFilterInput | null,
  owner?: string | null,
};

export type OnCreatePlaceRatingSubscription = {
  onCreatePlaceRating?:  {
    __typename: "PlaceRating",
    id: string,
    rating: number,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeRatingsId?: string | null,
    owner?: string | null,
  } | null,
};

export type OnUpdatePlaceRatingSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceRatingFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePlaceRatingSubscription = {
  onUpdatePlaceRating?:  {
    __typename: "PlaceRating",
    id: string,
    rating: number,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeRatingsId?: string | null,
    owner?: string | null,
  } | null,
};

export type OnDeletePlaceRatingSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceRatingFilterInput | null,
  owner?: string | null,
};

export type OnDeletePlaceRatingSubscription = {
  onDeletePlaceRating?:  {
    __typename: "PlaceRating",
    id: string,
    rating: number,
    place?:  {
      __typename: "Place",
      id: string,
      data:  {
        __typename: "PlaceData",
        name: string,
        alternateNames: Array< string >,
        location:  {
          __typename: "LatLon",
          lat: number,
          lon: number,
        },
        locationKnown: boolean,
        checked: boolean,
        checkedBy: string,
        spelioData:  {
          __typename: "SpelioData",
          systemName?: string | null,
          reference: string,
          source: string,
          type: LocationType,
          notes: string,
          caveRating: CaveRating,
          highestCaveRating?: CaveRating | null,
          tourismPotential: TourismPotential,
          accessDetails: string,
          verticalAccess: TriState,
          explorationPotential: ExplorationPotential,
          disabledAccessPotential: DisabledAccessPotential,
          files: Array< string >,
          labels: Array< string >,
          goesToWater: TriState,
          references:  Array< {
            __typename: "Reference",
            name: string,
            text: string,
          } >,
          surveyedLength?: number | null,
        },
        diveData?:  {
          __typename: "DiveData",
          minDepth?: number | null,
          maxDepth?: number | null,
          waterType: WaterType,
          isTidal: TriState,
          minTemp?: number | null,
          maxTemp?: number | null,
          difficulty?: Difficulty | null,
          entryDifficulty?: Difficulty | null,
          entryType?: EntryType | null,
        } | null,
        wreckData?:  {
          __typename: "WreckData",
          type?: string | null,
          built?: string | null,
          dateSunk?: string | null,
          length?: number | null,
          width?: number | null,
          draught?: number | null,
        } | null,
        address?:  {
          __typename: "Address",
          streetNumber?: string | null,
          street?: string | null,
          suburb?: string | null,
          state?: string | null,
          country?: string | null,
          postcode?: string | null,
          timezone?: string | null,
        } | null,
        altitude?: number | null,
        warnings?: Array< string > | null,
        amenities?:  {
          __typename: "Amenities",
          hasShowers: TriState,
          hasToilets: TriState,
          hasPhone?: TriState | null,
          food?: Rating | null,
          family?: Rating | null,
          parking?: Rating | null,
        } | null,
      },
      userAccess?: Array< string > | null,
      groupAccess?: Array< string > | null,
      reports?:  {
        __typename: "ModelPlaceReportConnection",
        items:  Array< {
          __typename: "PlaceReport",
          owner?: string | null,
          id: string,
          rating: number,
          waterTemp?: number | null,
          visibility?: ReportVisibility | null,
          swell?: ReportSwell | null,
          wind?: ReportWind | null,
          text: string,
          date: string,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeReportsId?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      ratings?:  {
        __typename: "ModelPlaceRatingConnection",
        items:  Array< {
          __typename: "PlaceRating",
          id: string,
          rating: number,
          place?:  {
            __typename: "Place",
            id: string,
            userAccess?: Array< string > | null,
            groupAccess?: Array< string > | null,
            softDeleted?: string | null,
            scubaCollection?: string | null,
            caveCollection?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeRatingsId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      media?:  {
        __typename: "ModelPlaceMediaItemConnection",
        items:  Array< {
          __typename: "PlaceMediaItem",
          id: string,
          owner?: string | null,
          groupAccess?: Array< string > | null,
          media?:  {
            __typename: "Media",
            id: string,
            contributorId?: string | null,
            mimeType: string,
            name?: string | null,
            description?: string | null,
            contentType?: MediaContentType | null,
            attribution?: string | null,
            attributionLink?: string | null,
            dateAdded?: string | null,
            dateCreated?: string | null,
          } | null,
          placeMediaId?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      softDeleted?: string | null,
      scubaCollection?: string | null,
      caveCollection?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeRatingsId?: string | null,
    owner?: string | null,
  } | null,
};

export type OnCreatePlaceMediaItemSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceMediaItemFilterInput | null,
};

export type OnCreatePlaceMediaItemSubscription = {
  onCreatePlaceMediaItem?:  {
    __typename: "PlaceMediaItem",
    id: string,
    owner?: string | null,
    groupAccess?: Array< string > | null,
    media?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    placeMediaId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdatePlaceMediaItemSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceMediaItemFilterInput | null,
};

export type OnUpdatePlaceMediaItemSubscription = {
  onUpdatePlaceMediaItem?:  {
    __typename: "PlaceMediaItem",
    id: string,
    owner?: string | null,
    groupAccess?: Array< string > | null,
    media?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    placeMediaId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeletePlaceMediaItemSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceMediaItemFilterInput | null,
};

export type OnDeletePlaceMediaItemSubscription = {
  onDeletePlaceMediaItem?:  {
    __typename: "PlaceMediaItem",
    id: string,
    owner?: string | null,
    groupAccess?: Array< string > | null,
    media?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    placeMediaId?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreatePlaceSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceFilterInput | null,
};

export type OnCreatePlaceSubscription = {
  onCreatePlace?:  {
    __typename: "Place",
    id: string,
    data:  {
      __typename: "PlaceData",
      name: string,
      alternateNames: Array< string >,
      location:  {
        __typename: "LatLon",
        lat: number,
        lon: number,
      },
      locationKnown: boolean,
      checked: boolean,
      checkedBy: string,
      spelioData:  {
        __typename: "SpelioData",
        systemName?: string | null,
        reference: string,
        source: string,
        type: LocationType,
        notes: string,
        caveRating: CaveRating,
        highestCaveRating?: CaveRating | null,
        tourismPotential: TourismPotential,
        accessDetails: string,
        verticalAccess: TriState,
        explorationPotential: ExplorationPotential,
        disabledAccessPotential: DisabledAccessPotential,
        files: Array< string >,
        labels: Array< string >,
        goesToWater: TriState,
        references:  Array< {
          __typename: "Reference",
          name: string,
          text: string,
        } >,
        surveyedLength?: number | null,
      },
      diveData?:  {
        __typename: "DiveData",
        minDepth?: number | null,
        maxDepth?: number | null,
        waterType: WaterType,
        isTidal: TriState,
        minTemp?: number | null,
        maxTemp?: number | null,
        difficulty?: Difficulty | null,
        entryDifficulty?: Difficulty | null,
        entryType?: EntryType | null,
      } | null,
      wreckData?:  {
        __typename: "WreckData",
        type?: string | null,
        built?: string | null,
        dateSunk?: string | null,
        length?: number | null,
        width?: number | null,
        draught?: number | null,
      } | null,
      address?:  {
        __typename: "Address",
        streetNumber?: string | null,
        street?: string | null,
        suburb?: string | null,
        state?: string | null,
        country?: string | null,
        postcode?: string | null,
        timezone?: string | null,
      } | null,
      altitude?: number | null,
      warnings?: Array< string > | null,
      amenities?:  {
        __typename: "Amenities",
        hasShowers: TriState,
        hasToilets: TriState,
        hasPhone?: TriState | null,
        food?: Rating | null,
        family?: Rating | null,
        parking?: Rating | null,
      } | null,
    },
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    reports?:  {
      __typename: "ModelPlaceReportConnection",
      items:  Array< {
        __typename: "PlaceReport",
        owner?: string | null,
        id: string,
        rating: number,
        waterTemp?: number | null,
        visibility?: ReportVisibility | null,
        swell?: ReportSwell | null,
        wind?: ReportWind | null,
        text: string,
        date: string,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeReportsId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    ratings?:  {
      __typename: "ModelPlaceRatingConnection",
      items:  Array< {
        __typename: "PlaceRating",
        id: string,
        rating: number,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeRatingsId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    media?:  {
      __typename: "ModelPlaceMediaItemConnection",
      items:  Array< {
        __typename: "PlaceMediaItem",
        id: string,
        owner?: string | null,
        groupAccess?: Array< string > | null,
        media?:  {
          __typename: "Media",
          id: string,
          contributorId?: string | null,
          mimeType: string,
          file:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail_256px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_512px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_1024px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          name?: string | null,
          description?: string | null,
          contentType?: MediaContentType | null,
          attribution?: string | null,
          attributionLink?: string | null,
          dateAdded?: string | null,
          dateCreated?: string | null,
        } | null,
        placeMediaId?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    softDeleted?: string | null,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdatePlaceSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceFilterInput | null,
};

export type OnUpdatePlaceSubscription = {
  onUpdatePlace?:  {
    __typename: "Place",
    id: string,
    data:  {
      __typename: "PlaceData",
      name: string,
      alternateNames: Array< string >,
      location:  {
        __typename: "LatLon",
        lat: number,
        lon: number,
      },
      locationKnown: boolean,
      checked: boolean,
      checkedBy: string,
      spelioData:  {
        __typename: "SpelioData",
        systemName?: string | null,
        reference: string,
        source: string,
        type: LocationType,
        notes: string,
        caveRating: CaveRating,
        highestCaveRating?: CaveRating | null,
        tourismPotential: TourismPotential,
        accessDetails: string,
        verticalAccess: TriState,
        explorationPotential: ExplorationPotential,
        disabledAccessPotential: DisabledAccessPotential,
        files: Array< string >,
        labels: Array< string >,
        goesToWater: TriState,
        references:  Array< {
          __typename: "Reference",
          name: string,
          text: string,
        } >,
        surveyedLength?: number | null,
      },
      diveData?:  {
        __typename: "DiveData",
        minDepth?: number | null,
        maxDepth?: number | null,
        waterType: WaterType,
        isTidal: TriState,
        minTemp?: number | null,
        maxTemp?: number | null,
        difficulty?: Difficulty | null,
        entryDifficulty?: Difficulty | null,
        entryType?: EntryType | null,
      } | null,
      wreckData?:  {
        __typename: "WreckData",
        type?: string | null,
        built?: string | null,
        dateSunk?: string | null,
        length?: number | null,
        width?: number | null,
        draught?: number | null,
      } | null,
      address?:  {
        __typename: "Address",
        streetNumber?: string | null,
        street?: string | null,
        suburb?: string | null,
        state?: string | null,
        country?: string | null,
        postcode?: string | null,
        timezone?: string | null,
      } | null,
      altitude?: number | null,
      warnings?: Array< string > | null,
      amenities?:  {
        __typename: "Amenities",
        hasShowers: TriState,
        hasToilets: TriState,
        hasPhone?: TriState | null,
        food?: Rating | null,
        family?: Rating | null,
        parking?: Rating | null,
      } | null,
    },
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    reports?:  {
      __typename: "ModelPlaceReportConnection",
      items:  Array< {
        __typename: "PlaceReport",
        owner?: string | null,
        id: string,
        rating: number,
        waterTemp?: number | null,
        visibility?: ReportVisibility | null,
        swell?: ReportSwell | null,
        wind?: ReportWind | null,
        text: string,
        date: string,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeReportsId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    ratings?:  {
      __typename: "ModelPlaceRatingConnection",
      items:  Array< {
        __typename: "PlaceRating",
        id: string,
        rating: number,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeRatingsId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    media?:  {
      __typename: "ModelPlaceMediaItemConnection",
      items:  Array< {
        __typename: "PlaceMediaItem",
        id: string,
        owner?: string | null,
        groupAccess?: Array< string > | null,
        media?:  {
          __typename: "Media",
          id: string,
          contributorId?: string | null,
          mimeType: string,
          file:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail_256px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_512px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_1024px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          name?: string | null,
          description?: string | null,
          contentType?: MediaContentType | null,
          attribution?: string | null,
          attributionLink?: string | null,
          dateAdded?: string | null,
          dateCreated?: string | null,
        } | null,
        placeMediaId?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    softDeleted?: string | null,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeletePlaceSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceFilterInput | null,
};

export type OnDeletePlaceSubscription = {
  onDeletePlace?:  {
    __typename: "Place",
    id: string,
    data:  {
      __typename: "PlaceData",
      name: string,
      alternateNames: Array< string >,
      location:  {
        __typename: "LatLon",
        lat: number,
        lon: number,
      },
      locationKnown: boolean,
      checked: boolean,
      checkedBy: string,
      spelioData:  {
        __typename: "SpelioData",
        systemName?: string | null,
        reference: string,
        source: string,
        type: LocationType,
        notes: string,
        caveRating: CaveRating,
        highestCaveRating?: CaveRating | null,
        tourismPotential: TourismPotential,
        accessDetails: string,
        verticalAccess: TriState,
        explorationPotential: ExplorationPotential,
        disabledAccessPotential: DisabledAccessPotential,
        files: Array< string >,
        labels: Array< string >,
        goesToWater: TriState,
        references:  Array< {
          __typename: "Reference",
          name: string,
          text: string,
        } >,
        surveyedLength?: number | null,
      },
      diveData?:  {
        __typename: "DiveData",
        minDepth?: number | null,
        maxDepth?: number | null,
        waterType: WaterType,
        isTidal: TriState,
        minTemp?: number | null,
        maxTemp?: number | null,
        difficulty?: Difficulty | null,
        entryDifficulty?: Difficulty | null,
        entryType?: EntryType | null,
      } | null,
      wreckData?:  {
        __typename: "WreckData",
        type?: string | null,
        built?: string | null,
        dateSunk?: string | null,
        length?: number | null,
        width?: number | null,
        draught?: number | null,
      } | null,
      address?:  {
        __typename: "Address",
        streetNumber?: string | null,
        street?: string | null,
        suburb?: string | null,
        state?: string | null,
        country?: string | null,
        postcode?: string | null,
        timezone?: string | null,
      } | null,
      altitude?: number | null,
      warnings?: Array< string > | null,
      amenities?:  {
        __typename: "Amenities",
        hasShowers: TriState,
        hasToilets: TriState,
        hasPhone?: TriState | null,
        food?: Rating | null,
        family?: Rating | null,
        parking?: Rating | null,
      } | null,
    },
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    reports?:  {
      __typename: "ModelPlaceReportConnection",
      items:  Array< {
        __typename: "PlaceReport",
        owner?: string | null,
        id: string,
        rating: number,
        waterTemp?: number | null,
        visibility?: ReportVisibility | null,
        swell?: ReportSwell | null,
        wind?: ReportWind | null,
        text: string,
        date: string,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeReportsId?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    ratings?:  {
      __typename: "ModelPlaceRatingConnection",
      items:  Array< {
        __typename: "PlaceRating",
        id: string,
        rating: number,
        place?:  {
          __typename: "Place",
          id: string,
          data:  {
            __typename: "PlaceData",
            name: string,
            alternateNames: Array< string >,
            locationKnown: boolean,
            checked: boolean,
            checkedBy: string,
            altitude?: number | null,
            warnings?: Array< string > | null,
          },
          userAccess?: Array< string > | null,
          groupAccess?: Array< string > | null,
          reports?:  {
            __typename: "ModelPlaceReportConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          ratings?:  {
            __typename: "ModelPlaceRatingConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          media?:  {
            __typename: "ModelPlaceMediaItemConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          softDeleted?: string | null,
          scubaCollection?: string | null,
          caveCollection?: string | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
        } | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeRatingsId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    media?:  {
      __typename: "ModelPlaceMediaItemConnection",
      items:  Array< {
        __typename: "PlaceMediaItem",
        id: string,
        owner?: string | null,
        groupAccess?: Array< string > | null,
        media?:  {
          __typename: "Media",
          id: string,
          contributorId?: string | null,
          mimeType: string,
          file:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          },
          thumbnail_256px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_512px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          thumbnail_1024px?:  {
            __typename: "S3Object",
            bucket: string,
            region: string,
            key: string,
          } | null,
          name?: string | null,
          description?: string | null,
          contentType?: MediaContentType | null,
          attribution?: string | null,
          attributionLink?: string | null,
          dateAdded?: string | null,
          dateCreated?: string | null,
        } | null,
        placeMediaId?: string | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    softDeleted?: string | null,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateJournalSubscriptionVariables = {
  filter?: ModelSubscriptionJournalFilterInput | null,
  owner?: string | null,
};

export type OnCreateJournalSubscription = {
  onCreateJournal?:  {
    __typename: "Journal",
    id: string,
    addedAt: string,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    modifications:  Array< {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } >,
    modification?:  {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } | null,
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    contributor?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateJournalSubscriptionVariables = {
  filter?: ModelSubscriptionJournalFilterInput | null,
  owner?: string | null,
};

export type OnUpdateJournalSubscription = {
  onUpdateJournal?:  {
    __typename: "Journal",
    id: string,
    addedAt: string,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    modifications:  Array< {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } >,
    modification?:  {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } | null,
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    contributor?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteJournalSubscriptionVariables = {
  filter?: ModelSubscriptionJournalFilterInput | null,
  owner?: string | null,
};

export type OnDeleteJournalSubscription = {
  onDeleteJournal?:  {
    __typename: "Journal",
    id: string,
    addedAt: string,
    scubaCollection?: string | null,
    caveCollection?: string | null,
    modifications:  Array< {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } >,
    modification?:  {
      __typename: "Modification",
      action: ModificationAction,
      model: ModificationModel,
      modelId: string,
      modelName: string,
      detail: string,
      collections?: string | null,
    } | null,
    userAccess?: Array< string > | null,
    groupAccess?: Array< string > | null,
    contributor?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUserInfoSubscriptionVariables = {
  filter?: ModelSubscriptionUserInfoFilterInput | null,
  owner?: string | null,
};

export type OnCreateUserInfoSubscription = {
  onCreateUserInfo?:  {
    __typename: "UserInfo",
    id: string,
    avatar?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    banner?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    displayName?: string | null,
    navigationAccuracy?: number | null,
    displayUnits?: DisplayUnits | null,
    socials?:  {
      __typename: "UserSocials",
      website?: string | null,
      facebook?: string | null,
      x?: string | null,
      blueSky?: string | null,
      instagram?: string | null,
    } | null,
    isTestAccount?: boolean | null,
    bio?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateUserInfoSubscriptionVariables = {
  filter?: ModelSubscriptionUserInfoFilterInput | null,
  owner?: string | null,
};

export type OnUpdateUserInfoSubscription = {
  onUpdateUserInfo?:  {
    __typename: "UserInfo",
    id: string,
    avatar?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    banner?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    displayName?: string | null,
    navigationAccuracy?: number | null,
    displayUnits?: DisplayUnits | null,
    socials?:  {
      __typename: "UserSocials",
      website?: string | null,
      facebook?: string | null,
      x?: string | null,
      blueSky?: string | null,
      instagram?: string | null,
    } | null,
    isTestAccount?: boolean | null,
    bio?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteUserInfoSubscriptionVariables = {
  filter?: ModelSubscriptionUserInfoFilterInput | null,
  owner?: string | null,
};

export type OnDeleteUserInfoSubscription = {
  onDeleteUserInfo?:  {
    __typename: "UserInfo",
    id: string,
    avatar?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    banner?:  {
      __typename: "Media",
      id: string,
      contributorId?: string | null,
      mimeType: string,
      file:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      },
      thumbnail_256px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_512px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      thumbnail_1024px?:  {
        __typename: "S3Object",
        bucket: string,
        region: string,
        key: string,
      } | null,
      name?: string | null,
      description?: string | null,
      contentType?: MediaContentType | null,
      attribution?: string | null,
      attributionLink?: string | null,
      dateAdded?: string | null,
      dateCreated?: string | null,
    } | null,
    displayName?: string | null,
    navigationAccuracy?: number | null,
    displayUnits?: DisplayUnits | null,
    socials?:  {
      __typename: "UserSocials",
      website?: string | null,
      facebook?: string | null,
      x?: string | null,
      blueSky?: string | null,
      instagram?: string | null,
    } | null,
    isTestAccount?: boolean | null,
    bio?: string | null,
    owner?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateUserFilterSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterFilterInput | null,
  owner?: string | null,
};

export type OnCreateUserFilterSubscription = {
  onCreateUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type OnUpdateUserFilterSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterFilterInput | null,
  owner?: string | null,
};

export type OnUpdateUserFilterSubscription = {
  onUpdateUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type OnDeleteUserFilterSubscriptionVariables = {
  filter?: ModelSubscriptionUserFilterFilterInput | null,
  owner?: string | null,
};

export type OnDeleteUserFilterSubscription = {
  onDeleteUserFilter?:  {
    __typename: "UserFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type OnCreatePublicFilterSubscriptionVariables = {
  filter?: ModelSubscriptionPublicFilterFilterInput | null,
};

export type OnCreatePublicFilterSubscription = {
  onCreatePublicFilter?:  {
    __typename: "PublicFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdatePublicFilterSubscriptionVariables = {
  filter?: ModelSubscriptionPublicFilterFilterInput | null,
};

export type OnUpdatePublicFilterSubscription = {
  onUpdatePublicFilter?:  {
    __typename: "PublicFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeletePublicFilterSubscriptionVariables = {
  filter?: ModelSubscriptionPublicFilterFilterInput | null,
};

export type OnDeletePublicFilterSubscription = {
  onDeletePublicFilter?:  {
    __typename: "PublicFilter",
    id: string,
    name: string,
    filterVersion: number,
    filter: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateModerationRequestSubscriptionVariables = {
  filter?: ModelSubscriptionModerationRequestFilterInput | null,
  owner?: string | null,
};

export type OnCreateModerationRequestSubscription = {
  onCreateModerationRequest?:  {
    __typename: "ModerationRequest",
    id: string,
    anonymous?: boolean | null,
    payload: string,
    type: ModerationRequestType,
    status: ModerationStatus,
    groupAccess?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type OnUpdateModerationRequestSubscriptionVariables = {
  filter?: ModelSubscriptionModerationRequestFilterInput | null,
  owner?: string | null,
};

export type OnUpdateModerationRequestSubscription = {
  onUpdateModerationRequest?:  {
    __typename: "ModerationRequest",
    id: string,
    anonymous?: boolean | null,
    payload: string,
    type: ModerationRequestType,
    status: ModerationStatus,
    groupAccess?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type OnDeleteModerationRequestSubscriptionVariables = {
  filter?: ModelSubscriptionModerationRequestFilterInput | null,
  owner?: string | null,
};

export type OnDeleteModerationRequestSubscription = {
  onDeleteModerationRequest?:  {
    __typename: "ModerationRequest",
    id: string,
    anonymous?: boolean | null,
    payload: string,
    type: ModerationRequestType,
    status: ModerationStatus,
    groupAccess?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type OnCreatePlaceListEntrySubscriptionVariables = {
  filter?: ModelSubscriptionPlaceListEntryFilterInput | null,
  owner?: string | null,
};

export type OnCreatePlaceListEntrySubscription = {
  onCreatePlaceListEntry?:  {
    __typename: "PlaceListEntry",
    id: string,
    placeList?:  {
      __typename: "PlaceList",
      id: string,
      name: string,
      description?: string | null,
      entries?:  {
        __typename: "ModelPlaceListEntryConnection",
        items:  Array< {
          __typename: "PlaceListEntry",
          id: string,
          placeList?:  {
            __typename: "PlaceList",
            id: string,
            name: string,
            description?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            owner?: string | null,
          } | null,
          place: string,
          order: number,
          checked?: boolean | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeListEntriesId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null,
    place: string,
    order: number,
    checked?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeListEntriesId?: string | null,
    owner?: string | null,
  } | null,
};

export type OnUpdatePlaceListEntrySubscriptionVariables = {
  filter?: ModelSubscriptionPlaceListEntryFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePlaceListEntrySubscription = {
  onUpdatePlaceListEntry?:  {
    __typename: "PlaceListEntry",
    id: string,
    placeList?:  {
      __typename: "PlaceList",
      id: string,
      name: string,
      description?: string | null,
      entries?:  {
        __typename: "ModelPlaceListEntryConnection",
        items:  Array< {
          __typename: "PlaceListEntry",
          id: string,
          placeList?:  {
            __typename: "PlaceList",
            id: string,
            name: string,
            description?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            owner?: string | null,
          } | null,
          place: string,
          order: number,
          checked?: boolean | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeListEntriesId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null,
    place: string,
    order: number,
    checked?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeListEntriesId?: string | null,
    owner?: string | null,
  } | null,
};

export type OnDeletePlaceListEntrySubscriptionVariables = {
  filter?: ModelSubscriptionPlaceListEntryFilterInput | null,
  owner?: string | null,
};

export type OnDeletePlaceListEntrySubscription = {
  onDeletePlaceListEntry?:  {
    __typename: "PlaceListEntry",
    id: string,
    placeList?:  {
      __typename: "PlaceList",
      id: string,
      name: string,
      description?: string | null,
      entries?:  {
        __typename: "ModelPlaceListEntryConnection",
        items:  Array< {
          __typename: "PlaceListEntry",
          id: string,
          placeList?:  {
            __typename: "PlaceList",
            id: string,
            name: string,
            description?: string | null,
            createdAt: string,
            updatedAt: string,
            _version: number,
            _deleted?: boolean | null,
            _lastChangedAt: number,
            owner?: string | null,
          } | null,
          place: string,
          order: number,
          checked?: boolean | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          placeListEntriesId?: string | null,
          owner?: string | null,
        } | null >,
        nextToken?: string | null,
        startedAt?: number | null,
      } | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
      owner?: string | null,
    } | null,
    place: string,
    order: number,
    checked?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    placeListEntriesId?: string | null,
    owner?: string | null,
  } | null,
};

export type OnCreatePlaceListSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceListFilterInput | null,
  owner?: string | null,
};

export type OnCreatePlaceListSubscription = {
  onCreatePlaceList?:  {
    __typename: "PlaceList",
    id: string,
    name: string,
    description?: string | null,
    entries?:  {
      __typename: "ModelPlaceListEntryConnection",
      items:  Array< {
        __typename: "PlaceListEntry",
        id: string,
        placeList?:  {
          __typename: "PlaceList",
          id: string,
          name: string,
          description?: string | null,
          entries?:  {
            __typename: "ModelPlaceListEntryConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          owner?: string | null,
        } | null,
        place: string,
        order: number,
        checked?: boolean | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeListEntriesId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type OnUpdatePlaceListSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceListFilterInput | null,
  owner?: string | null,
};

export type OnUpdatePlaceListSubscription = {
  onUpdatePlaceList?:  {
    __typename: "PlaceList",
    id: string,
    name: string,
    description?: string | null,
    entries?:  {
      __typename: "ModelPlaceListEntryConnection",
      items:  Array< {
        __typename: "PlaceListEntry",
        id: string,
        placeList?:  {
          __typename: "PlaceList",
          id: string,
          name: string,
          description?: string | null,
          entries?:  {
            __typename: "ModelPlaceListEntryConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          owner?: string | null,
        } | null,
        place: string,
        order: number,
        checked?: boolean | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeListEntriesId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};

export type OnDeletePlaceListSubscriptionVariables = {
  filter?: ModelSubscriptionPlaceListFilterInput | null,
  owner?: string | null,
};

export type OnDeletePlaceListSubscription = {
  onDeletePlaceList?:  {
    __typename: "PlaceList",
    id: string,
    name: string,
    description?: string | null,
    entries?:  {
      __typename: "ModelPlaceListEntryConnection",
      items:  Array< {
        __typename: "PlaceListEntry",
        id: string,
        placeList?:  {
          __typename: "PlaceList",
          id: string,
          name: string,
          description?: string | null,
          entries?:  {
            __typename: "ModelPlaceListEntryConnection",
            nextToken?: string | null,
            startedAt?: number | null,
          } | null,
          createdAt: string,
          updatedAt: string,
          _version: number,
          _deleted?: boolean | null,
          _lastChangedAt: number,
          owner?: string | null,
        } | null,
        place: string,
        order: number,
        checked?: boolean | null,
        createdAt: string,
        updatedAt: string,
        _version: number,
        _deleted?: boolean | null,
        _lastChangedAt: number,
        placeListEntriesId?: string | null,
        owner?: string | null,
      } | null >,
      nextToken?: string | null,
      startedAt?: number | null,
    } | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
    owner?: string | null,
  } | null,
};
